(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpl-age-calculator"] && !Shopify.designMode) return;
  try {
    
(function () {
  var STAGE_COPY = {
    dog: {
      puppy: {
        name: 'Puppy',
        interp: 'Your dog is in a fast-growth phase. Body, brain, and behavior are all wiring up at the same time, which is exciting and demanding in equal measure.',
        list: [
          'Rapid physical development and high energy bursts followed by deep sleep.',
          'Active socialization and learning windows.',
          'Sensitive digestion and a still-maturing immune system.'
        ],
        goal: 'Steady growth, a calm nervous system, and consistent routines. Focus on quality nutrition, predictable rest, and gentle daily structure.'
      },
      young: {
        name: 'Young Adult',
        interp: 'Your dog is in their physical prime — strong, agile, and emotionally settled. This is the foundation stage for long-term vitality.',
        list: [
          'Peak physical performance and stamina.',
          'Stable behavior patterns and clear preferences.',
          'High recovery capacity and resilience.'
        ],
        goal: 'Lock in consistency. Quality food, regular movement, restorative sleep, and routine wellness checks build the baseline that supports the next decade of life.'
      },
      mature: {
        name: 'Mature Adult',
        interp: 'Outwardly, little has changed. Internally, this is a quiet pivot. Cellular wear and oxidative stress begin to accumulate, and recovery time shifts.',
        list: [
          'Subtle changes in energy, recovery, and weight management.',
          'Joints and connective tissues begin to show normal wear.',
          'Cognitive sharpness remains, but the foundation matters more than ever.'
        ],
        goal: 'Begin proactive support for cellular energy, antioxidant defense, and joint comfort — well before visible signs of aging appear.'
      },
      senior: {
        name: 'Senior',
        interp: 'Your dog is in a stage where small changes matter. Comfort, cognition, and recovery deserve close, gentle attention.',
        list: [
          'Slower recovery from activity and possible joint stiffness.',
          'Shifts in sleep patterns and energy throughout the day.',
          'More sensitivity to environmental stress and routine changes.'
        ],
        goal: 'Help maintain comfort, mobility, and mental engagement. Gentle daily support, soft routines, and consistent connection are foundational.'
      },
      advanced: {
        name: 'Advanced Senior',
        interp: 'Your dog has earned a slower rhythm. The priority is dignity, comfort, and presence — not performance.',
        list: [
          'Lower energy and shorter activity windows.',
          'More need for warmth, soft surfaces, and quiet environments.',
          'Greater sensitivity to changes in food, schedule, and surroundings.'
        ],
        goal: 'Help maintain quality of life. Soft daily structure, gentle support, and close attention to subtle changes matter most now.'
      }
    },
    cat: {
      kitten: {
        name: 'Kitten',
        interp: 'Your cat is in a fast-growth stage. Coordination, social behavior, and physical structure are all developing rapidly.',
        list: [
          'Rapid growth and bursts of intense play.',
          'Active learning, especially around environment and people.',
          'Sensitive digestion and a maturing immune system.'
        ],
        goal: 'Steady growth and a calm environment. Quality nutrition, gentle handling, and predictable routines build a confident adult cat.'
      },
      young: {
        name: 'Young Adult',
        interp: 'Your cat is at their physical peak — agile, curious, and self-assured. This is the right stage to lock in habits that pay off later.',
        list: [
          'Peak agility, hunting drive, and stamina.',
          'Stable social patterns and well-defined preferences.',
          'Strong recovery and resilience.'
        ],
        goal: 'Consistency. Clean hydration, quality nutrition, daily play, and a low-stress environment build the foundation for a long, healthy life.'
      },
      mature: {
        name: 'Mature Adult',
        interp: 'Outwardly, your cat looks the same. Internally, this is a quiet but meaningful window. Cellular wear and oxidative stress begin to shift.',
        list: [
          'Subtle changes in activity level and weight management.',
          'Slightly slower recovery after intense play.',
          'Cognitive sharpness intact, but groundwork starts mattering more.'
        ],
        goal: 'Begin proactive support for cellular energy and antioxidant defense, well before visible signs of aging appear.'
      },
      senior: {
        name: 'Senior',
        interp: 'Your cat is at a stage where small changes matter. Mobility, hydration, and comfort deserve close, gentle attention.',
        list: [
          'Reduced jumping height and slower movement after rest.',
          'Shifts in sleep patterns and grooming routines.',
          'More sensitivity to environmental and dietary changes.'
        ],
        goal: 'Help maintain comfort, mobility, and engagement. Soft surfaces, easy access to favorite spots, and gentle daily support carry weight here.'
      },
      advanced: {
        name: 'Advanced Senior',
        interp: 'Your cat is in a stage that asks for stillness, warmth, and close attention. The priority is dignity and quality of daily life.',
        list: [
          'Lower energy and shorter active windows.',
          'Greater need for warmth, soft surfaces, and quiet.',
          'More sensitivity to changes in food, schedule, and environment.'
        ],
        goal: 'Help maintain quality of life through gentle daily structure, careful observation of subtle changes, and consistent, supportive routines.'
      }
    }
  };

  function ageFromDob(dobStr) {
    if (!dobStr) return null;
    var dob = new Date(dobStr);
    if (isNaN(dob.getTime())) return null;
    var now = new Date();
    if (dob > now) return null;
    var years = now.getFullYear() - dob.getFullYear();
    var months = now.getMonth() - dob.getMonth();
    var days = now.getDate() - dob.getDate();
    if (days < 0) months -= 1;
    if (months < 0) { years -= 1; months += 12; }
    return { years: years, months: months };
  }

  function convert(ageY, sp, size) {
    if (ageY <= 0) return 0;
    if (ageY <= 1) return ageY * 15;
    if (ageY <= 2) return 15 + (ageY - 1) * 9;
    var increment;
    if (sp === 'dog') {
      increment = ({ small: 4, medium: 5, large: 6, giant: 7 })[size] || 5;
    } else {
      increment = 4;
    }
    return 24 + (ageY - 2) * increment;
  }

  var OFFER_COPY = {
    puppy:  'One simple daily habit that grows with them.',
    kitten: 'One simple daily habit that grows with them.',
    young:  'Their prime years are the window to lock in daily support.',
    mature: 'The right window to begin daily support for cellular energy and antioxidant defense \u2014 before visible signs of aging appear.',
    senior: 'Gentle daily support for comfort, cognition, and vitality \u2014 built into one simple routine.',
    advanced: 'Soft, consistent daily support focused on quality of life.'
  };

  function lifeStage(ageY, sp, size) {
    if (sp === 'cat') {
      if (ageY < 1) return 'kitten';
      if (ageY < 4) return 'young';
      if (ageY < 7) return 'mature';
      if (ageY < 11) return 'senior';
      return 'advanced';
    }
    var brackets = ({
      small:  [1, 4, 8, 12],
      medium: [1, 4, 7, 11],
      large:  [1, 3, 6, 9],
      giant:  [1, 3, 5, 8]
    })[size] || [1, 4, 7, 11];
    if (ageY < brackets[0]) return 'puppy';
    if (ageY < brackets[1]) return 'young';
    if (ageY < brackets[2]) return 'mature';
    if (ageY < brackets[3]) return 'senior';
    return 'advanced';
  }

  function formatHuman(num) {
    if (num < 10) return (Math.round(num * 10) / 10).toString();
    return Math.round(num).toString();
  }

  function init(root) {
    if (root.dataset.lplInit === '1') return;
    root.dataset.lplInit = '1';

    var species = root.getAttribute('data-species') || 'dog';
    var form    = root.querySelector('[data-lpl-form]');
    if (!form) return;

    var modeBtns       = form.querySelectorAll('.lpl-ac-mode-btn');
    var paneAge        = form.querySelector('[data-pane="age"]');
    var paneDob        = form.querySelector('[data-pane="dob"]');
    var yearsEl        = form.querySelector('[data-field="years"]');
    var monthsEl       = form.querySelector('[data-field="months"]');
    var dobEl          = form.querySelector('[data-field="dob"]');
    var errorEl        = form.querySelector('[data-error]');
    var resetBtn       = form.querySelector('[data-reset]');
    var resultEl       = root.querySelector('[data-result]');
    var resultNum      = root.querySelector('[data-result-number]');
    var resultSummary  = root.querySelector('[data-result-summary]');
    var stageNameEl    = root.querySelector('[data-stage-name]');
    var stageInterpEl  = root.querySelector('[data-stage-interp]');
    var stageListEl    = root.querySelector('[data-stage-list]');
    var stageGoalEl    = root.querySelector('[data-stage-goal]');
    var offerKicker    = root.querySelector('[data-offer-kicker]');
    var offerLine      = root.querySelector('[data-offer-line]');

    var mode = 'age';

    function clearError() { errorEl.hidden = true; errorEl.textContent = ''; }
    function setError(msg) { errorEl.textContent = msg; errorEl.hidden = false; }
    function speciesLabel() { return species === 'dog' ? 'dog' : 'cat'; }

    modeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        mode = btn.getAttribute('data-mode');
        modeBtns.forEach(function (b) {
          var active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        paneAge.classList.toggle('is-hidden', mode !== 'age');
        paneDob.classList.toggle('is-hidden', mode !== 'dob');
        clearError();
      });
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        form.reset();
        if (resultEl) resultEl.hidden = true;
        clearError();
      });
    }

    function render(humanAge, stageKey) {
      var copy = STAGE_COPY[species][stageKey];
      if (!copy) return;
      resultNum.textContent = formatHuman(humanAge);
      resultSummary.textContent = 'Your ' + speciesLabel() + ' is approximately ' + formatHuman(humanAge) + ' human years old.';
      stageNameEl.textContent = copy.name;
      stageInterpEl.textContent = copy.interp;
      stageListEl.innerHTML = '';
      copy.list.forEach(function (item) {
        var li = document.createElement('li');
        li.textContent = item;
        stageListEl.appendChild(li);
      });
      stageGoalEl.textContent = copy.goal;
      if (offerKicker) offerKicker.textContent = 'For the ' + copy.name.toLowerCase() + ' years';
      if (offerLine && OFFER_COPY[stageKey]) offerLine.textContent = OFFER_COPY[stageKey];
      resultEl.hidden = false;
      requestAnimationFrame(function () {
        resultEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError();

      var years = 0;
      var months = 0;

      if (mode === 'age') {
        years = parseInt(yearsEl.value, 10);
        months = parseInt(monthsEl.value, 10);
        if (isNaN(years)) years = 0;
        if (isNaN(months)) months = 0;
        if (years < 0 || months < 0) { setError('Please enter a positive number.'); return; }
        if (months > 11) { setError('Months must be between 0 and 11.'); return; }
        if (years === 0 && months === 0) { setError('Please enter your ' + speciesLabel() + '’s age.'); return; }
        if (years > 30) { setError('Please enter a realistic age.'); return; }
      } else {
        var parsed = ageFromDob(dobEl.value);
        if (!parsed) { setError('Please enter a valid date of birth.'); return; }
        years = parsed.years;
        months = parsed.months;
        if (years === 0 && months === 0) { setError('Date of birth must be in the past.'); return; }
      }

      var size = null;
      if (species === 'dog') {
        var sizeInput = form.querySelector('input[name="size"]:checked');
        size = sizeInput ? sizeInput.value : 'medium';
      }

      var ageY = years + months / 12;
      var human = convert(ageY, species, size);
      var stage = lifeStage(ageY, species, size);
      render(human, stage);
    });
  }

  function ready() {
    document.querySelectorAll('[data-lpl-ac]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-lpl-ac]');
    if (root) init(root);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpl-biological-age-calculator"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SYSTEMS = [
    { key: 'mobility_strength', label: 'Mobility & strength', fields: ['muscle', 'mobility', 'activity'] },
    { key: 'metabolic', label: 'Metabolic/body condition', fields: ['bcs', 'chronic'] },
    { key: 'recovery_sleep', label: 'Recovery & sleep', fields: ['recovery', 'sleep'] },
    { key: 'cognition_behavior', label: 'Cognition & behavior', fields: ['cognition'] },
    { key: 'digestive', label: 'Digestive stability', fields: ['digestion'] },
    { key: 'barrier', label: 'Skin/coat/barrier', fields: ['coat'] },
    { key: 'oral', label: 'Oral health', fields: ['dental'] }
  ];

  var SCORES = {
    bcs: { under: 1, lean: -1, ideal: -1, above: 1, significant: 3, unsure: 0.5 },
    muscle: { normal: 0, mild: 1, moderate: 2, severe: 3, unsure: 0.5 },
    mobility: { normal: 0, slower: 1, difficulty: 2, help: 3 },
    activity: { daily: -1, moderate: 0, low: 1, very_low: 2 },
    recovery: { normal: 0, slower: 1, next_day: 2, avoids: 3 },
    sleep: { steady: 0, more: 0.5, restless: 2, major: 3 },
    cognition: { normal: 0, mild: 1, moderate: 2.5, frequent: 3.5 },
    digestion: { stable: 0, minor: 0.5, recurring: 2, significant: 3 },
    coat: { healthy: 0, mild: 0.5, recurring: 1.5, major: 2.5 },
    dental: { clean: 0, mild: 0.5, visible: 2, pain: 3.5 },
    chronic: { no: 0, yes: 2, unsure: 0.5 }
  };

  var LABELS = {
    bcs: 'Body condition',
    muscle: 'Muscle / strength',
    mobility: 'Mobility',
    activity: 'Activity',
    recovery: 'Recovery',
    sleep: 'Sleep',
    cognition: 'Cognition / behavior',
    digestion: 'Appetite / digestion',
    coat: 'Coat / skin / grooming',
    dental: 'Dental / oral',
    chronic: 'Chronic condition context'
  };

  var POSITIVE = {
    bcs: 'Body condition is in the lean-to-ideal range.',
    muscle: 'Muscle and strength are not pulling the signal older.',
    mobility: 'Mobility appears age-aligned.',
    activity: 'Daily activity is a younger/aligned functional signal.',
    recovery: 'Recovery after activity is steady.',
    sleep: 'Sleep and rest pattern are steady.',
    cognition: 'Cognition and behavior appear stable.',
    digestion: 'Appetite and digestion appear stable.',
    coat: 'Coat, skin, and grooming appear stable.',
    dental: 'No obvious oral-health signal was selected.',
    chronic: 'No diagnosed chronic condition was selected.'
  };

  var OLDER = {
    bcs: 'Body condition may be adding metabolic load.',
    muscle: 'Muscle or strength loss may be pulling the functional signal older.',
    mobility: 'Mobility changes are one of the strongest functional-aging signals.',
    activity: 'Lower activity can narrow resilience and recovery windows.',
    recovery: 'Slower recovery suggests the return-to-baseline pattern is shifting.',
    sleep: 'Sleep disruption or major sleep-wake change can make aging feel faster.',
    cognition: 'Behavior or cognition changes are worth documenting for your veterinarian.',
    digestion: 'Recurring appetite or stool changes can affect daily resilience.',
    coat: 'Coat, skin, or grooming changes can reflect barrier and self-care shifts.',
    dental: 'Oral discomfort signals can affect appetite, mood, and daily comfort.',
    chronic: 'Diagnosed chronic conditions can change the functional-aging context.'
  };

  function ageFromDob(dobStr) {
    if (!dobStr) return null;
    var dob = new Date(dobStr);
    if (isNaN(dob.getTime())) return null;
    var now = new Date();
    if (dob > now) return null;
    var years = now.getFullYear() - dob.getFullYear();
    var months = now.getMonth() - dob.getMonth();
    var days = now.getDate() - dob.getDate();
    if (days < 0) months -= 1;
    if (months < 0) { years -= 1; months += 12; }
    return { years: years, months: months };
  }

  function convertDogAge(ageY, size) {
    if (ageY <= 0) return 0;
    if (ageY <= 1) return ageY * 15;
    if (ageY <= 2) return 15 + (ageY - 1) * 9;
    var inc = ({ small: 4, medium: 5, large: 6, giant: 7 })[size] || 5;
    return 24 + (ageY - 2) * inc;
  }

  function lifeStage(ageY, size) {
    var brackets = ({ small: [1, 4, 8, 12], medium: [1, 4, 7, 11], large: [1, 3, 6, 9], giant: [1, 3, 5, 8] })[size] || [1, 4, 7, 11];
    if (ageY < brackets[0]) return 'Puppy';
    if (ageY < brackets[1]) return 'Young adult';
    if (ageY < brackets[2]) return 'Mature adult';
    if (ageY < brackets[3]) return 'Senior';
    return 'Advanced senior';
  }

  function zoneFor(score) {
    if (score <= -1) return { short: 'Younger', name: 'Younger-than-expected functional signal', delta: -5, text: 'Observable signals look somewhat younger or more resilient than expected for the chronological age. Keep the same habits and use this as a baseline.' };
    if (score <= 4) return { short: 'Aligned', name: 'Age-aligned functional signal', delta: 0, text: 'Observable signals are broadly aligned with chronological age. Repeat every 30-90 days to track the curve.' };
    if (score <= 8) return { short: 'Mild', name: 'Mildly accelerated aging signal', delta: 5, text: 'A few domains are pulling the functional signal older. This is a useful moment to tighten routine and document patterns.' };
    if (score <= 13) return { short: 'Moderate', name: 'Moderately accelerated aging signal', delta: 10, text: 'Multiple domains are pulling the signal older. A veterinary conversation can help separate normal aging from addressable issues.' };
    return { short: 'Strong', name: 'Strongly accelerated aging signal / vet review recommended', delta: 16, text: 'Several systems are signaling faster functional aging. Schedule veterinary review, especially if changes are new, progressive, or affecting comfort.' };
  }

  function systemBand(value) {
    if (value <= 0) return 'Strong';
    if (value <= 1) return 'Aligned';
    if (value <= 2.5) return 'Watch';
    return 'Discuss';
  }

  function init(root) {
    if (root.dataset.lplInit === '1') return;
    root.dataset.lplInit = '1';

    var form = root.querySelector('[data-lpl-form]');
    if (!form) return;

    var modeBtns = form.querySelectorAll('.lpl-ac-mode-btn');
    var paneAge = form.querySelector('[data-pane="age"]');
    var paneDob = form.querySelector('[data-pane="dob"]');
    var yearsEl = form.querySelector('[data-field="years"]');
    var monthsEl = form.querySelector('[data-field="months"]');
    var dobEl = form.querySelector('[data-field="dob"]');
    var resetBtn = form.querySelector('[data-reset]');
    var errorEl = form.querySelector('[data-error]');
    var resultEl = root.querySelector('[data-result]');
    var paceShortEl = root.querySelector('[data-pace-short]');
    var zoneEl = root.querySelector('[data-zone]');
    var ageCompareEl = root.querySelector('[data-age-compare]');
    var chronoEl = root.querySelector('[data-chronological]');
    var profileEl = root.querySelector('[data-system-profile]');
    var wellEl = root.querySelector('[data-aging-well]');
    var olderEl = root.querySelector('[data-aging-older]');
    var mode = 'age';

    function clearError() { errorEl.hidden = true; errorEl.textContent = ''; }
    function setError(msg) { errorEl.textContent = msg; errorEl.hidden = false; }

    modeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        mode = btn.getAttribute('data-mode');
        modeBtns.forEach(function (b) {
          var active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        paneAge.classList.toggle('is-hidden', mode !== 'age');
        paneDob.classList.toggle('is-hidden', mode !== 'dob');
        clearError();
      });
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        form.reset();
        if (resultEl) resultEl.hidden = true;
        clearError();
      });
    }

    function choice(name) {
      var el = form.querySelector('input[name="' + name + '"]:checked');
      return el ? el.value : null;
    }

    function addListItem(list, text) {
      var li = document.createElement('li');
      li.textContent = text;
      list.appendChild(li);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError();

      var years = 0;
      var months = 0;
      if (mode === 'age') {
        years = parseInt(yearsEl.value, 10);
        months = parseInt(monthsEl.value, 10);
        if (isNaN(years)) years = 0;
        if (isNaN(months)) months = 0;
        if (years < 0 || months < 0) { setError('Please enter a positive number.'); return; }
        if (months > 11) { setError('Months must be between 0 and 11.'); return; }
        if (years === 0 && months === 0) { setError('Please enter your dog’s age.'); return; }
        if (years > 30) { setError('Please enter a realistic age.'); return; }
      } else {
        var parsed = ageFromDob(dobEl.value);
        if (!parsed) { setError('Please enter a valid date of birth.'); return; }
        years = parsed.years;
        months = parsed.months;
        if (years === 0 && months === 0) { setError('Date of birth must be in the past.'); return; }
      }

      var size = choice('size') || 'medium';
      var ageY = years + months / 12;
      var human = convertDogAge(ageY, size);

      var fields = Object.keys(SCORES);
      var fieldScores = {};
      var total = 0;
      fields.forEach(function (name) {
        var val = choice(name);
        var s = SCORES[name][val];
        if (typeof s !== 'number') s = 0;
        fieldScores[name] = s;
        total += s;
      });

      var zone = zoneFor(total);
      var low = Math.max(1, Math.round((human + zone.delta - 3) / 2) * 2);
      var high = Math.max(low + 2, Math.round((human + zone.delta + 3) / 2) * 2);
      var stage = lifeStage(ageY, size);

      paceShortEl.textContent = zone.short;
      zoneEl.textContent = zone.name + '. ' + zone.text;
      ageCompareEl.textContent = 'Estimated functional-age signal: roughly aligned with a dog aged ' + low + '-' + high + ' human-equivalent years.';
      chronoEl.textContent = 'Chronological age: ' + years + ' year' + (years === 1 ? '' : 's') + ', ' + months + ' month' + (months === 1 ? '' : 's') + '. Size category: ' + size + '. Life stage: ' + stage + '. Human-year equivalent from the age calculator logic: about ' + Math.round(human) + '.';

      profileEl.innerHTML = '';
      SYSTEMS.forEach(function (system) {
        var value = system.fields.reduce(function (sum, name) { return sum + (fieldScores[name] || 0); }, 0) / system.fields.length;
        var row = document.createElement('div');
        row.className = 'wi-lens-row';
        row.innerHTML = '<span class="wi-lens-label"></span><span class="wi-lens-value"></span>';
        row.querySelector('.wi-lens-label').textContent = system.label;
        row.querySelector('.wi-lens-value').textContent = systemBand(value);
        profileEl.appendChild(row);
      });

      var positives = fields.filter(function (name) { return fieldScores[name] <= 0; }).slice(0, 4);
      var older = fields.slice().sort(function (a, b) { return fieldScores[b] - fieldScores[a]; }).filter(function (name) { return fieldScores[name] > 0; }).slice(0, 4);
      wellEl.innerHTML = '';
      olderEl.innerHTML = '';
      if (!positives.length) addListItem(wellEl, 'No clearly younger/aligned domain stood out today. Use the systems profile for prioritization.');
      positives.forEach(function (name) { addListItem(wellEl, POSITIVE[name]); });
      if (!older.length) addListItem(olderEl, 'No domain is clearly pulling the signal older today. Save this as a baseline.');
      older.forEach(function (name) { addListItem(olderEl, LABELS[name] + ': ' + OLDER[name]); });

      resultEl.hidden = false;
      requestAnimationFrame(function () {
        resultEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function ready() {
    document.querySelectorAll('[data-lpl-ba]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-lpl-ba]');
    if (root) init(root);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpl-body-condition-tool"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Per-input scoring on the BCS scale (1 = under, 5 = significantly above).
  var SCORE = {
    rib:   { heavy: 5, ideal: 3, lean: 2, under: 1 },
    waist: { heavy: 5, above: 4, ideal: 3, under: 1 },
    tuck:  { heavy: 5, above: 4, ideal: 3, under: 1 }
  };

  // Activity nudges the score slightly (sedentary tends to mask, athletic tends to expose).
  var ACTIVITY_ADJ = { low: 0.2, moderate: 0, high: -0.2 };

  function categorize(score) {
    if (score <= 1.5) return 'under';
    if (score <= 2.4) return 'lean';
    if (score <= 3.4) return 'ideal';
    if (score <= 4.4) return 'above';
    return 'sig';
  }

  var CATEGORY_NAMES = {
    under: 'Underconditioned',
    lean:  'Lean',
    ideal: 'Ideal condition',
    above: 'Above ideal condition',
    sig:   'Significantly above ideal condition'
  };

  var SCALE_LABELS = {
    under: 'BCS 1–2 of 5',
    lean:  'BCS 2 of 5',
    ideal: 'BCS 3 of 5',
    above: 'BCS 4 of 5',
    sig:   'BCS 5 of 5'
  };

  var COPY = {
    dog: {
      under: {
        summary: 'Your dog appears to be carrying less body reserve than is typical for this life stage. Bones may feel quite prominent, with limited muscle padding. This may be intentional and stable — or it may be worth a closer look.',
        notice:   'Ribs, spine, and hipbones may be visibly prominent. Muscle along the back and hindquarters may feel reduced. Coat may appear slightly less full.',
        mobility: 'Lower body reserves can affect recovery from illness, injury, or intense activity. Energy may be reduced on harder days.',
        longevity:'Adequate body reserves are protective in senior years and during recovery from any stressor. Confirming the lean state is intentional and stable matters.',
        support:  'Focus on nutrient-dense, high-quality food and steady meal timing. Avoid sudden calorie increases — body composition responds better to consistency than to volume.',
        vet: [
          'Is this body condition clinically appropriate for my dog?',
          'Could anything underlying be contributing to the low body reserves?',
          'What is the best path back to ideal condition, and over what timeframe?',
          'Are there any nutrient priorities I should pay closer attention to right now?'
        ]
      },
      lean: {
        summary: 'Your dog appears to be on the lean end of the healthy range. Body composition is light, with clearly defined waist and tuck. This is often an excellent place to be, provided it is intentional and stable.',
        notice:   'Ribs are easily felt with very thin fat covering. Waist is clearly defined from above; tuck is clearly defined from the side. Movement is typically light and easy.',
        mobility: 'Lean body composition is typically associated with strong mobility and efficient recovery. Less mechanical load on joints; faster bounce-back from activity.',
        longevity:'Lean body composition is one of the most consistent correlates of longer, healthier life in dogs — provided it is stable and not the result of unintentional weight loss.',
        support:  'Maintain quality nutrition and consistent feeding. Monitor monthly to make sure the lean state is stable. Continue daily movement appropriate to life stage.',
        vet: [
          'Is this lean state intentional, stable, and clinically appropriate?',
          'Is the current feeding plan supporting healthy lean muscle?',
          'Are there any markers I should monitor at this body condition?'
        ]
      },
      ideal: {
        summary: 'Your dog appears to be at ideal body condition. Ribs are easily felt with a slight fat covering, the waist is clearly visible from above, and the tuck is defined from the side. This is the body composition associated with the longest, most mobile years.',
        notice:   'Ribs feel like the back of your hand — palpable, not protruding. A clear narrowing behind the ribcage from above. A defined tuck from the side. Smooth movement and easy recovery.',
        mobility: 'Ideal body condition supports efficient movement and resilient recovery. Mechanical load on joints is minimized; recovery from activity is steady.',
        longevity:'Ideal body condition is one of the strongest daily levers on healthy aging — influencing mobility, recovery, inflammatory load, and metabolic resilience over time.',
        support:  'Maintain the foundation: quality nutrition tuned to activity, daily movement, restorative sleep, and consistent feeding. Monthly body-condition checks confirm stability.',
        vet: [
          'Is my current feeding plan supporting this ideal condition?',
          'How often should we re-check body condition at this life stage?',
          'Are there any life-stage shifts coming up that might change my plan?'
        ]
      },
      above: {
        summary: 'Your dog appears to be carrying some weight above ideal condition. Ribs are harder to feel, the waist is less defined, and the tuck is softer than ideal. A gradual, supported return toward ideal is generally the most useful goal.',
        notice:   'Ribs may require firmer pressure to feel. Waist from above is mild or absent. Belly tucks less than usual. Movement may be slightly slower to settle after activity.',
        mobility: 'Extra body weight increases mechanical load on joints and reduces recovery efficiency. Even small reductions toward ideal often show up in everyday movement.',
        longevity:'Body condition above ideal is associated with quieter, cumulative effects on joints, recovery, and metabolic health over time. Gradual return supports long-term mobility and resilience.',
        support:  'Small, steady adjustments outperform aggressive cuts. Slightly reduce portions, tighten treat intake to under 10% of daily calories, and add daily movement appropriate to the dog. Monthly body-condition checks reveal direction.',
        vet: [
          'Is a structured plan to return toward ideal condition appropriate now?',
          'What weekly or monthly pace of change is realistic and safe?',
          'Are there any underlying factors that might be contributing?',
          'How should the feeding plan and treats be adjusted?'
        ]
      },
      sig: {
        summary: 'Your dog appears to be carrying meaningful weight above ideal condition. Ribs are difficult to feel, waist and tuck are minimal, and mechanical load on joints is meaningfully increased. A gradual, vet-guided plan is generally the most supportive path forward.',
        notice:   'Ribs are difficult to feel without firm pressure. Waist from above is absent. Belly may sag below the ribcage line. Movement may be visibly slower to settle.',
        mobility: 'Significant excess body weight meaningfully increases joint load and reduces recovery efficiency. Mobility, breathing comfort during activity, and recovery from exercise are typically affected.',
        longevity:'Body condition meaningfully above ideal is one of the most consistent negative correlates of long, mobile life. Gradual, monitored change supports recovery, mobility, and metabolic resilience.',
        support:  'A structured, vet-guided plan is the most supportive path. Aggressive change is rarely the answer; consistent, monitored, gradual change tends to work better. Track body condition monthly, not the scale daily.',
        vet: [
          'Can we build a structured, monitored plan to return toward ideal condition?',
          'What pace of change is safe given my dog\'s life stage and health?',
          'Are there underlying factors — metabolic, mobility, or otherwise — to investigate?',
          'How should daily meals, treats, and activity be adjusted together?'
        ]
      }
    },
    cat: {
      under: {
        summary: 'Your cat appears to be carrying less body reserve than is typical for this life stage. Bones may feel quite prominent, with limited muscle padding. In cats, unintentional weight loss deserves prompt attention from a veterinarian.',
        notice:   'Spine, shoulder blades, and hipbones may be visibly prominent. Muscle along the back and hindquarters may feel reduced. Coat may appear less full or less smooth.',
        mobility: 'Lower body reserves can affect recovery from illness, injury, or stress. Energy and grooming behavior may shift quietly.',
        longevity:'Adequate body reserves are protective in senior years. In cats, unintentional weight loss is one of the earliest signals of changes that deserve veterinary attention.',
        support:  'Focus on nutrient-dense, palatable food and frequent small meals. Wet food often helps with both calorie and hydration intake. Avoid sudden changes without veterinary guidance.',
        vet: [
          'Is this body condition clinically appropriate, or is something underlying contributing?',
          'Should we run baseline diagnostics given this body condition?',
          'What is the best path back to ideal condition, and over what timeframe?',
          'Are there feeding adjustments that would best support this cat right now?'
        ]
      },
      lean: {
        summary: 'Your cat appears to be on the lean end of the healthy range. Body composition is light, with clearly defined waist and abdomen. This is often an excellent place to be, provided it is intentional and stable.',
        notice:   'Ribs are easily felt with very thin fat covering. Clear waist from above; flat or gently tucked abdomen from the side. Movement is light, jumping easy.',
        mobility: 'Lean body composition is typically associated with strong agility and efficient recovery. Less mechanical load; easier jumping and climbing.',
        longevity:'Lean body composition is one of the most consistent correlates of longer, healthier life in cats — provided it is stable and not the result of unintentional weight loss.',
        support:  'Maintain quality nutrition and consistent feeding. Monitor monthly to confirm the lean state is stable. Continue daily play appropriate to life stage.',
        vet: [
          'Is this lean state intentional, stable, and clinically appropriate?',
          'Is the current feeding plan supporting healthy lean muscle?',
          'Are there any markers worth monitoring at this body condition?'
        ]
      },
      ideal: {
        summary: 'Your cat appears to be at ideal body condition. Ribs are easily felt with a slight fat covering, the waist is clearly visible from above, and the abdomen is flat or gently tucked from the side. This is the body composition associated with the longest, most agile years.',
        notice:   'Ribs feel like the back of your hand — palpable, not protruding. A clear narrowing behind the ribcage from above. A flat or gently tucked abdomen from the side. Smooth, easy movement and jumping.',
        mobility: 'Ideal body condition supports efficient movement, easy jumping, and resilient recovery. Mechanical load on joints is minimized.',
        longevity:'Ideal body condition is one of the strongest daily levers on healthy aging in cats — influencing mobility, recovery, inflammatory load, and metabolic resilience over time.',
        support:  'Maintain the foundation: quality nutrition tuned to indoor or outdoor lifestyle, daily play, hydration support, and consistent feeding. Monthly body-condition checks confirm stability.',
        vet: [
          'Is my current feeding plan supporting this ideal condition?',
          'How often should we re-check body condition at this life stage?',
          'Are there any life-stage shifts coming up that might change my plan?'
        ]
      },
      above: {
        summary: 'Your cat appears to be carrying some weight above ideal condition. Ribs are harder to feel, the waist is less defined, and the abdomen sits a little fuller than ideal. In cats, change must be gradual and ideally guided by a veterinarian.',
        notice:   'Ribs may require firmer pressure to feel. Waist from above is mild or absent. Abdomen may sit lower than the ribcage line. Jumping or grooming reach may shift quietly.',
        mobility: 'Extra body weight increases mechanical load on joints and reduces recovery efficiency. Some cats begin avoiding higher perches or grooming less thoroughly.',
        longevity:'Body condition above ideal is associated with quieter cumulative effects on joints, recovery, and metabolic health over time. Gradual return supports long-term mobility and resilience.',
        support:  'In cats, slow and steady is essential — rapid calorie restriction can lead to serious metabolic complications. Small portion adjustments, more frequent play, and strategic use of wet food are useful daily levers. Monthly body-condition checks reveal direction.',
        vet: [
          'Can we build a slow, monitored plan to return toward ideal condition?',
          'What pace of change is safe in a cat — and what should I avoid?',
          'How should daily meals, treats, water, and play be adjusted together?',
          'Are there any underlying factors worth investigating?'
        ]
      },
      sig: {
        summary: 'Your cat appears to be carrying meaningful weight above ideal condition. Ribs are difficult to feel, waist is absent, and the abdomen may sag. In cats, weight management must be gradual and vet-guided — rapid calorie restriction can be dangerous.',
        notice:   'Ribs are difficult to feel without firm pressure. Waist from above is absent. Abdomen may sag visibly. Jumping, grooming, and play behavior may have shifted.',
        mobility: 'Significant excess body weight increases joint load, reduces grooming reach, and reduces recovery efficiency. Mobility and daily comfort are typically affected.',
        longevity:'Body condition meaningfully above ideal is one of the most consistent negative correlates of long, mobile life in cats. Gradual, monitored change supports recovery and metabolic resilience.',
        support:  'A vet-guided plan is essential in cats at this body condition. Rapid calorie restriction can lead to serious metabolic complications. Steady, monitored change combined with hydration support and daily play tends to be the most supportive path.',
        vet: [
          'Can we design a slow, monitored, safe plan to return toward ideal condition?',
          'What baseline diagnostics would be useful before starting?',
          'How should the feeding plan be structured to avoid metabolic risk?',
          'How should hydration and play be integrated into the plan?'
        ]
      }
    }
  };

  // CTA copy and product set per category.
  function ctaFor(category, species, hollywoodUrl, petgalaUrl) {
    var name = species === 'dog' ? 'dog' : 'cat';
    if (category === 'ideal' || category === 'lean') {
      return {
        eyebrow: 'For the long road ahead',
        heading: 'Support graceful aging from the inside out.',
        text:    'Maintaining ideal body condition is one of the strongest daily levers on healthy aging. Hollywood Elixir is designed to support cellular energy, antioxidant defense, immune balance, and recovery — daily inputs that compound over time.',
        actions: [{ label: 'Explore Hollywood Elixir', url: hollywoodUrl }]
      };
    }
    if (category === 'under') {
      return {
        eyebrow: 'A supportive companion',
        heading: 'Nutrient density and cellular support matter most here.',
        text:    'When body reserves are lower than ideal, nutrient density, recovery, and cellular resilience become especially relevant. Hollywood Elixir is designed to support cellular energy, antioxidant defense, and recovery — alongside a vet-guided plan.',
        actions: [{ label: 'Explore Hollywood Elixir', url: hollywoodUrl }]
      };
    }
    // above / sig
    return {
      eyebrow: 'Aligned support during change',
      heading: 'Support recovery, resilience, and skin & coat through gradual change.',
      text:    'Body condition shifts gradually, and the systems that support that change — recovery, inflammatory balance, mobility, and skin & coat quality — benefit from consistent daily inputs. Hollywood Elixir supports cellular energy and recovery; Pet Gala supports skin, coat, and barrier integrity (especially relevant when grooming reach shifts in heavier ' + name + 's).',
      actions: [
        { label: 'Explore Hollywood Elixir', url: hollywoodUrl, ghost: false },
        { label: 'Explore Pet Gala',         url: petgalaUrl,   ghost: true }
      ]
    };
  }

  function init(root) {
    if (root.dataset.lplInit === '1') return;
    root.dataset.lplInit = '1';

    var species = root.getAttribute('data-species') || 'dog';
    var form = root.querySelector('[data-lpl-form]');
    if (!form) return;

    var errorEl = form.querySelector('[data-error]');
    var resetBtn = form.querySelector('[data-reset]');
    var resultEl = root.querySelector('[data-result]');
    var visualEl = root.querySelector('[data-result-visual]');
    var resvgs   = root.querySelectorAll('.lpl-bc-resvg');
    var nameEl   = root.querySelector('[data-result-name]');
    var scaleEl  = root.querySelector('[data-result-scale]');
    var summaryEl = root.querySelector('[data-result-summary]');
    var noticeEl  = root.querySelector('[data-notice]');
    var mobilityEl = root.querySelector('[data-mobility]');
    var longevityEl = root.querySelector('[data-longevity]');
    var supportEl = root.querySelector('[data-support]');
    var vetEl = root.querySelector('[data-vet]');

    var ctaEl       = root.querySelector('[data-cta]');
    var ctaEyebrow  = root.querySelector('[data-cta-eyebrow]');
    var ctaHeading  = root.querySelector('[data-cta-heading]');
    var ctaText     = root.querySelector('[data-cta-text]');
    var ctaActions  = root.querySelector('[data-cta-actions]');

    var hollywoodUrl = root.getAttribute('data-hollywood-url') || '';
    var petgalaUrl   = root.getAttribute('data-petgala-url')   || '';

    function clearError() { errorEl.hidden = true; errorEl.textContent = ''; }
    function setError(msg) { errorEl.textContent = msg; errorEl.hidden = false; }

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        form.reset();
        if (resultEl) resultEl.hidden = true;
        clearError();
      });
    }

    function fillList(el, items) {
      el.innerHTML = '';
      items.forEach(function (item) {
        var li = document.createElement('li');
        li.textContent = item;
        el.appendChild(li);
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError();

      var rib   = (form.querySelector('input[name="rib"]:checked')   || {}).value;
      var waist = (form.querySelector('input[name="waist"]:checked') || {}).value;
      var tuck  = (form.querySelector('input[name="tuck"]:checked')  || {}).value;

      if (!rib || !waist || !tuck) {
        setError('Please select an option for each visual question.');
        return;
      }

      var activity = (form.querySelector('input[name="activity"]:checked') || {}).value || 'moderate';

      var raw = (SCORE.rib[rib] + SCORE.waist[waist] + SCORE.tuck[tuck]) / 3;
      raw += (ACTIVITY_ADJ[activity] || 0);
      // Clamp 1-5
      if (raw < 1) raw = 1;
      if (raw > 5) raw = 5;

      var category = categorize(raw);
      var copy = COPY[species][category];

      // Visual
      resvgs.forEach(function (s) {
        var match = s.getAttribute('data-bcs') === category;
        s.classList.toggle('is-active', match);
        if (match) s.removeAttribute('hidden');
        else s.setAttribute('hidden', '');
      });

      nameEl.textContent = CATEGORY_NAMES[category];
      scaleEl.textContent = SCALE_LABELS[category];
      summaryEl.textContent = copy.summary;
      noticeEl.textContent = copy.notice;
      mobilityEl.textContent = copy.mobility;
      longevityEl.textContent = copy.longevity;
      supportEl.textContent = copy.support;
      fillList(vetEl, copy.vet);

      // CTA
      if (ctaEl) {
        var cta = ctaFor(category, species, hollywoodUrl, petgalaUrl);
        ctaEyebrow.textContent = cta.eyebrow;
        ctaHeading.textContent = cta.heading;
        ctaText.textContent = cta.text;
        ctaActions.innerHTML = '';
        cta.actions.forEach(function (a) {
          if (!a.url) return;
          var btn = document.createElement('a');
          btn.href = a.url;
          btn.className = 'lpl-bc-cta-btn' + (a.ghost ? ' lpl-bc-cta-btn--ghost' : '');
          btn.textContent = a.label;
          ctaActions.appendChild(btn);
        });
        ctaEl.hidden = false;
      }

      resultEl.hidden = false;
      requestAnimationFrame(function () {
        resultEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function ready() {
    document.querySelectorAll('[data-lpl-bc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-lpl-bc]');
    if (root) init(root);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpl-calorie-calculator"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Multipliers over RER (Resting Energy Requirement = 70 * kg^0.75)
  // Indexed by species -> age -> activity. Intact baseline; neutered modifier applied separately.
  var MULT = {
    dog: {
      puppy:  { low: 2.0, moderate: 2.5, high: 3.0 },
      adult:  { low: 1.4, moderate: 1.6, high: 2.0 },
      senior: { low: 1.2, moderate: 1.4, high: 1.6 }
    },
    cat: {
      kitten: { low: 2.0, moderate: 2.5, high: 3.0 },
      adult:  { low: 1.2, moderate: 1.4, high: 1.6 },
      senior: { low: 1.1, moderate: 1.2, high: 1.4 }
    }
  };

  // Neutered modifier (applied only to adult & senior; growing animals not adjusted).
  var NEUTERED_MOD = 0.9;

  // Body-condition goal modifier on top of maintenance.
  var GOAL_MOD = { maintain: 1.0, lose: 0.8, gain: 1.15 };

  // Interpretation copy keyed by species_age_activity
  var INTERP = {
    dog: {
      puppy:  {
        low:      'Even a quieter puppy is in a fast-growth window. Calorie needs are high, but quality and consistency matter even more than quantity.',
        moderate: 'This is typical for a growing puppy with steady daily play and short walks. Frequent, structured meals support healthy growth.',
        high:     'Active, fast-growing puppies can need two to three times the maintenance calories of an adult their eventual size.'
      },
      adult: {
        low:      'This is typical for an adult dog with limited daily activity. Consistency of intake matters more than novelty at this stage.',
        moderate: 'This is typical for a moderately active adult dog. Most healthy adults sit comfortably in this range with daily movement.',
        high:     'This is typical for a working, sporting, or highly active adult dog. Calorie needs scale meaningfully with sustained effort.'
      },
      senior: {
        low:      'Senior dogs typically need fewer calories than they did as adults, but the importance of nutrient density and recovery support increases.',
        moderate: 'A moderately active senior dog often sits slightly below their adult intake. Quality and consistency outweigh quantity at this stage.',
        high:     'Even active senior dogs typically need slightly fewer calories than they did as adults, with greater attention to recovery and joint comfort.'
      }
    },
    cat: {
      kitten: {
        low:      'Even a calmer kitten is in a fast-growth phase. Calorie needs are high, with quality protein and frequent meals as the foundation.',
        moderate: 'This is typical for a growing kitten with regular play and exploration. Frequent meals support healthy growth.',
        high:     'Active, fast-growing kittens can need two to three times the maintenance calories of an adult cat per pound of body weight.'
      },
      adult: {
        low:      'This is typical for an adult indoor cat. Indoor cats generally need fewer calories than active outdoor cats — movement, not personality, is the variable.',
        moderate: 'This is typical for an adult cat with regular play and indoor activity. Sustained daily movement keeps this range steady.',
        high:     'This is typical for an active, often outdoor, adult cat. Hunting, climbing, and temperature regulation all add to daily calorie demand.'
      },
      senior: {
        low:      'Senior cats typically need slightly fewer calories, but nutrient density, hydration, and recovery support become more important.',
        moderate: 'A moderately active senior cat often sits slightly below their adult intake, with greater emphasis on maintaining lean muscle.',
        high:     'Even active senior cats typically need slightly fewer calories than they did as adults, with greater attention to recovery and lean muscle.'
      }
    }
  };

  var LIFESTAGE = {
    dog: {
      puppy:  'Puppies are building structure, immunity, and behavior at the same time. The goal is steady growth — quality protein, predictable meals, and a calm nervous system.',
      adult:  'Adult dogs benefit most from consistency. A steady daily intake tuned to activity level builds the foundation for long-term vitality.',
      senior: 'Senior dogs benefit from nutrient density, recovery support, and a thoughtful daily rhythm. Calorie needs decline; nutritional quality should not.'
    },
    cat: {
      kitten: 'Kittens grow at a remarkable pace. The goal is steady growth — high-quality protein, frequent meals, and a calm environment.',
      adult:  'Adult cats benefit from consistency. A steady daily intake tuned to indoor or outdoor lifestyle builds the foundation for long-term vitality.',
      senior: 'Senior cats benefit from nutrient density, hydration, and recovery support. Maintaining lean muscle is a quiet but pivotal goal in older cats.'
    }
  };

  function getWeightGuidance(goal, sp) {
    if (goal === 'lose') {
      if (sp === 'cat') {
        return 'Cats should not lose weight quickly — rapid calorie restriction can lead to serious metabolic complications. Any feline weight-loss plan should be designed and monitored by your veterinarian.';
      }
      return 'Healthy weight loss is slow. Reassess body condition every two to four weeks and avoid aggressive calorie cuts that compromise muscle and recovery. A veterinarian can help guide pace.';
    }
    if (goal === 'gain') {
      return 'Healthy weight gain is gradual. If your pet has been losing weight unintentionally — or struggling to gain despite adequate intake — discuss the underlying cause with your veterinarian.';
    }
    return 'Body condition is the best feedback loop — observe over weeks, not days. If your pet is gaining or losing weight unintentionally, discuss calorie adjustments with your veterinarian.';
  }

  function getTreatGuidance(target, treatPct) {
    if (treatPct == null || treatPct <= 0) {
      return 'Veterinary guidance generally recommends keeping treats under 10% of daily intake. For this estimate, that is roughly ' + Math.round(target * 0.10) + ' calories per day.';
    }
    var treatCals = Math.round(target * (treatPct / 100));
    var mealCals = Math.round(target - treatCals);
    return 'At ' + treatPct + '% from treats, aim to keep treats under ~' + treatCals + ' kcal/day, with ~' + mealCals + ' kcal from balanced meals.';
  }

  function calc(weightKg, sp, age, activity, neutered, goal) {
    var rer = 70 * Math.pow(weightKg, 0.75);
    var base = (MULT[sp][age] && MULT[sp][age][activity]) || 1.4;
    var adjusted = base;
    if (neutered && (age === 'adult' || age === 'senior')) {
      adjusted = base * NEUTERED_MOD;
    }
    adjusted *= (GOAL_MOD[goal] || 1.0);
    return rer * adjusted;
  }

  function formatCal(n) {
    if (n < 100) return Math.round(n).toString();
    return Math.round(n / 5) * 5 + '';
  }

  function init(root) {
    if (root.dataset.lplInit === '1') return;
    root.dataset.lplInit = '1';

    var species = root.getAttribute('data-species') || 'dog';
    var form = root.querySelector('[data-lpl-form]');
    if (!form) return;

    var weightEl   = form.querySelector('[data-field="weight"]');
    var neuteredEl = form.querySelector('[data-field="neutered"]');
    var treatsEl   = form.querySelector('[data-field="treats"]');
    var sliderVal  = form.querySelector('[data-slider-value]');
    var errorEl    = form.querySelector('[data-error]');
    var resetBtn   = form.querySelector('[data-reset]');
    var resultEl   = root.querySelector('[data-result]');
    var numEl      = root.querySelector('[data-result-number]');
    var rangeEl    = root.querySelector('[data-result-range]');
    var bandMarker = root.querySelector('[data-band-marker]');
    var bandSpan   = root.querySelector('[data-band-span]');
    var interpEl   = root.querySelector('[data-interp]');
    var treatBlock = root.querySelector('[data-treat-block]');
    var treatEl    = root.querySelector('[data-treats]');
    var weightOutEl = root.querySelector('[data-weight]');
    var lifestageEl = root.querySelector('[data-lifestage]');

    function clearError() { errorEl.hidden = true; errorEl.textContent = ''; }
    function setError(msg) { errorEl.textContent = msg; errorEl.hidden = false; }

    // Slider live value
    if (treatsEl && sliderVal) {
      var syncSlider = function () { sliderVal.textContent = treatsEl.value + '%'; };
      treatsEl.addEventListener('input', syncSlider);
      syncSlider();
    }

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        form.reset();
        if (treatsEl && sliderVal) sliderVal.textContent = treatsEl.value + '%';
        if (resultEl) resultEl.hidden = true;
        clearError();
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError();

      var weight = parseFloat(weightEl.value);
      if (isNaN(weight) || weight <= 0) { setError('Please enter your ' + species + '’s weight.'); return; }

      var unitInput = form.querySelector('input[name="unit"]:checked');
      var unit = unitInput ? unitInput.value : 'lb';
      var weightKg = unit === 'kg' ? weight : weight / 2.20462;

      // Sanity check
      var maxKg = species === 'dog' ? 110 : 15;
      if (weightKg > maxKg) { setError('Please enter a realistic weight.'); return; }
      if (weightKg < 0.2) { setError('Please enter a realistic weight.'); return; }

      var ageInput      = form.querySelector('input[name="age"]:checked');
      var activityInput = form.querySelector('input[name="activity"]:checked');
      var goalInput     = form.querySelector('input[name="goal"]:checked');

      var age      = ageInput ? ageInput.value : 'adult';
      var activity = activityInput ? activityInput.value : 'moderate';
      var goal     = goalInput ? goalInput.value : 'maintain';
      var neutered = neuteredEl ? neuteredEl.checked : true;

      var target = calc(weightKg, species, age, activity, neutered, goal);
      var low = target * 0.93;
      var high = target * 1.07;

      numEl.textContent = formatCal(target);
      rangeEl.textContent = 'Typical range: ' + formatCal(low) + '–' + formatCal(high) + ' kcal / day';

      // Range band update — dogs span ~150–3500 kcal/day; cats ~70–600.
      if (bandMarker && bandSpan) {
        var domLo = species === 'cat' ? 70 : 150;
        var domHi = species === 'cat' ? 600 : 3500;
        var clampPct = function (v) {
          return Math.max(0, Math.min(100, (v - domLo) / (domHi - domLo) * 100));
        };
        bandMarker.style.left = clampPct(target) + '%';
        var lp = clampPct(low), hp = clampPct(high);
        bandSpan.style.left = lp + '%';
        bandSpan.style.width = (hp - lp) + '%';
      }

      var interpCopy = (INTERP[species][age] && INTERP[species][age][activity]) || '';
      if (neutered && (age === 'adult' || age === 'senior')) {
        interpCopy += ' Neutered pets typically need around 10–20% fewer calories than intact pets — already reflected here.';
      }
      interpEl.textContent = interpCopy;

      var treatPct = treatsEl ? parseInt(treatsEl.value, 10) : null;
      if (treatBlock && treatEl) {
        if (species === 'dog') {
          treatBlock.hidden = false;
          treatEl.textContent = getTreatGuidance(target, treatPct);
        } else {
          treatBlock.hidden = false;
          treatEl.textContent = getTreatGuidance(target, null);
        }
      }

      weightOutEl.textContent = getWeightGuidance(goal, species);
      lifestageEl.textContent = LIFESTAGE[species][age] || '';

      resultEl.hidden = false;
      requestAnimationFrame(function () {
        resultEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function ready() {
    document.querySelectorAll('[data-lpl-cc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-lpl-cc]');
    if (root) init(root);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpl-cat-biological-age-calculator"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SCORES = {
    bcs: { under: 1, lean: -1, ideal: -2, above: 2, significant: 4, unsure: 1 },
    muscle: { normal: -1, mild: 2, moderate: 4, severe: 6, unsure: 1 },
    mobility: { normal: -1, slower: 1, difficulty: 4, help: 6 },
    activity: { daily: -1, moderate: 0, low: 2, very_low: 4 },
    recovery: { normal: -1, slower: 1, next_day: 3, avoids: 5 },
    sleep: { steady: -1, more: 1, restless: 3, major: 5 },
    cognition: { normal: -1, mild: 1, moderate: 4, frequent: 6 },
    digestion: { stable: -1, minor: 1, recurring: 3, significant: 5 },
    hydration: { stable: -1, minor: 1, noticeable: 3, significant: 5 },
    coat: { healthy: -1, mild: 1, recurring: 3, major: 5 },
    dental: { clean: -1, mild: 1, visible: 3, pain: 5 },
    chronic: { no: 0, yes: 4, unsure: 1 }
  };
  var LABELS = {
    bcs: 'Body condition',
    muscle: 'Muscle / strength',
    mobility: 'Mobility / jumping',
    activity: 'Activity / enrichment',
    recovery: 'Recovery',
    sleep: 'Sleep / night rhythm',
    cognition: 'Cognition / household navigation',
    digestion: 'Appetite / digestion',
    hydration: 'Hydration / litter box',
    coat: 'Coat / grooming',
    dental: 'Dental / oral',
    chronic: 'Chronic health context'
  };
  var POSITIVE = {
    bcs: 'Body condition is supporting the functional-aging signal.',
    muscle: 'Muscle and strength appear aligned today.',
    mobility: 'Jumping, climbing, and essential access look steady.',
    activity: 'Daily activity or enrichment is a younger/aligned functional signal.',
    recovery: 'Recovery after play or exertion appears steady.',
    sleep: 'Sleep and night rhythm appear steady.',
    cognition: 'Household navigation and interactions appear steady.',
    digestion: 'Appetite and digestion appear stable.',
    hydration: 'Water interest and litter-box rhythm appear stable.',
    coat: 'Grooming and coat condition appear steady.',
    dental: 'No obvious oral-health signal was selected.'
  };
  var OLDER = {
    bcs: 'Body condition can affect mobility, metabolism, grooming reach, and daily comfort.',
    muscle: 'Muscle loss can pull the functional-aging signal older, especially around hips, spine, and shoulders.',
    mobility: 'Jumping, climbing, and litter-box access are strong feline functional-aging signals.',
    activity: 'Lower activity can reflect slower recovery, comfort change, reduced enrichment, or shifting routine.',
    recovery: 'Slower recovery suggests the return-to-baseline pattern is changing.',
    sleep: 'Restlessness, night waking, or vocalization can make aging feel faster.',
    cognition: 'Household navigation, night rhythm, and interaction changes are worth documenting.',
    digestion: 'Recurring appetite, stool, or vomiting changes can pull the signal older.',
    hydration: 'Water interest, urine clumps, stool, or litter-box changes deserve careful tracking.',
    coat: 'Grooming and coat changes can reflect flexibility, comfort, energy, or skin/coat barrier shifts.',
    dental: 'Oral discomfort signals can affect appetite, mood, grooming, and daily comfort.',
    chronic: 'A diagnosed chronic condition can make functional aging more variable and worth monitoring.'
  };
  var SYSTEMS = [
    { label: 'Mobility & strength', fields: ['mobility', 'muscle', 'recovery'] },
    { label: 'Metabolic/body condition', fields: ['bcs', 'activity'] },
    { label: 'Recovery & sleep', fields: ['recovery', 'sleep'] },
    { label: 'Cognition & household rhythm', fields: ['cognition', 'sleep'] },
    { label: 'Digestive & hydration stability', fields: ['digestion', 'hydration'] },
    { label: 'Skin/coat/grooming', fields: ['coat', 'mobility'] },
    { label: 'Oral health', fields: ['dental'] }
  ];

  function ageFromDob(value) {
    if (!value) return null;
    var dob = new Date(value + 'T00:00:00');
    if (isNaN(dob.getTime())) return null;
    var now = new Date();
    if (dob > now) return null;
    var years = now.getFullYear() - dob.getFullYear();
    var months = now.getMonth() - dob.getMonth();
    var days = now.getDate() - dob.getDate();
    if (days < 0) months -= 1;
    if (months < 0) { years -= 1; months += 12; }
    return { years: years, months: months };
  }
  function convertCatAge(ageY) {
    if (ageY <= 0) return 0;
    if (ageY <= 1) return ageY * 15;
    if (ageY <= 2) return 15 + (ageY - 1) * 9;
    return 24 + (ageY - 2) * 4;
  }
  function lifeStage(ageY) {
    if (ageY < 1) return 'Kitten';
    if (ageY < 4) return 'Young adult';
    if (ageY < 7) return 'Mature adult';
    if (ageY < 11) return 'Senior';
    if (ageY < 15) return 'Advanced senior';
    return 'Geriatric / advanced senior';
  }
  function zoneFor(score) {
    if (score <= -1) return { short: 'Younger', name: 'Younger-than-expected functional signal', delta: -5, text: 'Observable signals look somewhat younger or more resilient than expected for chronological age. Keep the same habits and use this as a baseline.' };
    if (score <= 4) return { short: 'Aligned', name: 'Age-aligned functional signal', delta: 0, text: 'Observable signals are broadly aligned with chronological age. Repeat every 30-90 days to track the curve.' };
    if (score <= 9) return { short: 'Mild', name: 'Mildly accelerated aging signal', delta: 5, text: 'A few feline systems are pulling the functional signal older. This is a useful moment to document patterns.' };
    if (score <= 15) return { short: 'Moderate', name: 'Moderately accelerated aging signal', delta: 10, text: 'Multiple systems are pulling the signal older. A veterinary conversation can help separate normal aging from addressable issues.' };
    return { short: 'Strong', name: 'Strongly accelerated aging signal / vet review recommended', delta: 16, text: 'Several systems are signaling faster functional aging. Schedule veterinary review, especially if changes are new, progressive, or affecting comfort.' };
  }
  function systemBand(value) {
    if (value <= 0) return 'Strong';
    if (value <= 1) return 'Aligned';
    if (value <= 2.5) return 'Watch';
    return 'Discuss';
  }

  function init(root) {
    if (root.dataset.lplInit === '1') return;
    root.dataset.lplInit = '1';
    var form = root.querySelector('[data-lpl-form]');
    if (!form) return;

    var modeBtns = form.querySelectorAll('.lpl-ac-mode-btn');
    var paneAge = form.querySelector('[data-pane="age"]');
    var paneDob = form.querySelector('[data-pane="dob"]');
    var yearsEl = form.querySelector('[data-field="years"]');
    var monthsEl = form.querySelector('[data-field="months"]');
    var dobEl = form.querySelector('[data-field="dob"]');
    var resetBtn = form.querySelector('[data-reset]');
    var errorEl = form.querySelector('[data-error]');
    var resultEl = root.querySelector('[data-result]');
    var paceShortEl = root.querySelector('[data-pace-short]');
    var zoneEl = root.querySelector('[data-zone]');
    var ageCompareEl = root.querySelector('[data-age-compare]');
    var chronoEl = root.querySelector('[data-chronological]');
    var profileEl = root.querySelector('[data-system-profile]');
    var wellEl = root.querySelector('[data-aging-well]');
    var olderEl = root.querySelector('[data-aging-older]');
    var mode = 'age';

    function clearError() { errorEl.hidden = true; errorEl.textContent = ''; }
    function setError(msg) { errorEl.textContent = msg; errorEl.hidden = false; }
    function choice(name) {
      var el = form.querySelector('input[name="' + name + '"]:checked');
      return el ? el.value : null;
    }
    function addListItem(list, text) {
      var li = document.createElement('li');
      li.textContent = text;
      list.appendChild(li);
    }

    modeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        mode = btn.getAttribute('data-mode');
        modeBtns.forEach(function (b) {
          var active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        paneAge.classList.toggle('is-hidden', mode !== 'age');
        paneDob.classList.toggle('is-hidden', mode !== 'dob');
        clearError();
      });
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        form.reset();
        if (resultEl) resultEl.hidden = true;
        clearError();
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError();
      var years = 0;
      var months = 0;
      if (mode === 'age') {
        years = parseInt(yearsEl.value, 10);
        months = parseInt(monthsEl.value, 10);
        if (isNaN(years)) years = 0;
        if (isNaN(months)) months = 0;
        if (years < 0 || months < 0) { setError('Please enter a positive number.'); return; }
        if (months > 11) { setError('Months must be between 0 and 11.'); return; }
        if (years === 0 && months === 0) { setError('Please enter your cat’s age.'); return; }
        if (years > 30) { setError('Please enter a realistic age.'); return; }
      } else {
        var parsed = ageFromDob(dobEl.value);
        if (!parsed) { setError('Please enter a valid date of birth.'); return; }
        years = parsed.years;
        months = parsed.months;
        if (years === 0 && months === 0) { setError('Date of birth must be in the past.'); return; }
      }

      var ageY = years + months / 12;
      var human = convertCatAge(ageY);
      var fields = Object.keys(SCORES);
      var fieldScores = {};
      var total = 0;
      fields.forEach(function (name) {
        var val = choice(name);
        var s = SCORES[name][val];
        if (typeof s !== 'number') s = 0;
        fieldScores[name] = s;
        total += s;
      });

      var zone = zoneFor(total);
      var low = Math.max(1, Math.round((human + zone.delta - 3) / 2) * 2);
      var high = Math.max(low + 2, Math.round((human + zone.delta + 3) / 2) * 2);
      var stage = lifeStage(ageY);

      paceShortEl.textContent = zone.short;
      zoneEl.textContent = zone.name + '. ' + zone.text;
      ageCompareEl.textContent = 'Estimated functional-age signal: roughly aligned with a cat aged ' + low + '-' + high + ' human-equivalent years.';
      chronoEl.textContent = 'Chronological age: ' + years + ' year' + (years === 1 ? '' : 's') + ', ' + months + ' month' + (months === 1 ? '' : 's') + '. Life stage: ' + stage + '. Human-year equivalent from the cat age calculator logic: about ' + Math.round(human) + '.';

      profileEl.innerHTML = '';
      SYSTEMS.forEach(function (system) {
        var value = system.fields.reduce(function (sum, name) { return sum + (fieldScores[name] || 0); }, 0) / system.fields.length;
        var row = document.createElement('div');
        row.className = 'wi-lens-row';
        row.innerHTML = '<span class="wi-lens-label"></span><span class="wi-lens-value"></span>';
        row.querySelector('.wi-lens-label').textContent = system.label;
        row.querySelector('.wi-lens-value').textContent = systemBand(value);
        profileEl.appendChild(row);
      });

      var positives = fields.filter(function (name) { return fieldScores[name] <= 0 && POSITIVE[name]; }).slice(0, 4);
      var older = fields.slice().sort(function (a, b) { return fieldScores[b] - fieldScores[a]; }).filter(function (name) { return fieldScores[name] > 0; }).slice(0, 4);
      wellEl.innerHTML = '';
      olderEl.innerHTML = '';
      if (!positives.length) addListItem(wellEl, 'No clearly younger/aligned domain stood out today. Use the systems profile for prioritization.');
      positives.forEach(function (name) { addListItem(wellEl, POSITIVE[name]); });
      if (!older.length) addListItem(olderEl, 'No domain is clearly pulling the signal older today. Save this as a baseline.');
      older.forEach(function (name) { addListItem(olderEl, LABELS[name] + ': ' + OLDER[name]); });

      resultEl.hidden = false;
      requestAnimationFrame(function () { resultEl.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    });
  }

  function ready() { document.querySelectorAll('[data-lpl-cat-bioage]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-lpl-cat-bioage]');
    if (root) init(root);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpl-cat-quality-of-life-scale"] && !Shopify.designMode) return;
  try {
    
(function () {
  var DOMAINS = [
    { key: 'comfort', label: 'Comfort', note: 'Comfort signals are clearer when you can describe posture, touch sensitivity, hiding, vocalization, and what happens after rest.' },
    { key: 'appetite', label: 'Appetite', note: 'Appetite and weight trends are useful with dates, food amounts, treats, vomiting notes, and recent photos.' },
    { key: 'hydration', label: 'Hydration/litter box', note: 'Drinking, urine clumps, stool, accidents, and box avoidance are practical patterns to bring to your veterinarian.' },
    { key: 'grooming', label: 'Grooming/coat', note: 'Grooming changes can reflect comfort, flexibility, skin/coat barrier, energy, or access to normal self-care.' },
    { key: 'mobility', label: 'Mobility/access', note: 'Mobility is easiest to discuss with short videos of jumping, stairs, litter-box entry, grooming posture, and favorite perches.' },
    { key: 'engagement', label: 'Engagement/hiding', note: 'Engagement includes contact, play, windows, resting places, hiding, vocalization, and household rhythm.' },
    { key: 'gooddays', label: 'Good-day pattern', note: 'Good-day versus difficult-day patterns help your veterinarian understand the trend over time.' }
  ];

  function domainBand(score) {
    if (score <= 1) return 'Low';
    if (score === 2) return 'Watch';
    if (score === 3) return 'Discuss';
    return 'Urgent';
  }

  function zoneFor(signal) {
    if (signal >= 85) return { name: 'Stable / strong daily-life signal', text: 'Your answers describe a strong daily-life pattern today. Keep tracking the domains that matter most so changes are easy to see early.' };
    if (signal >= 70) return { name: 'Generally good, watch specific domains', text: 'Your cat’s overall signal is generally good, with a few domains worth watching. Save this note and repeat it to see whether those areas settle or trend upward.' };
    if (signal >= 50) return { name: 'Mixed signal; useful to discuss with veterinarian', text: 'The pattern is mixed. This is a useful time to bring a concise note to your veterinarian, especially around the highest-scoring domains.' };
    if (signal >= 30) return { name: 'Concerning signal; schedule veterinary review', text: 'Several daily-life domains are carrying concern. Schedule a veterinary review and bring examples, videos, and recent changes.' };
    return { name: 'Serious concern; prompt veterinary guidance', text: 'The answers suggest a serious daily-life concern. Please seek prompt veterinary guidance, especially if the pattern is new or worsening.' };
  }

  function init(root) {
    if (root.dataset.lplInit === '1') return;
    root.dataset.lplInit = '1';
    var form = root.querySelector('[data-lpl-form]');
    if (!form) return;

    var resultEl = root.querySelector('[data-result]');
    var scoreEl = root.querySelector('[data-score]');
    var zoneEl = root.querySelector('[data-zone]');
    var interpEl = root.querySelector('[data-interpretation]');
    var mapEl = root.querySelector('[data-domain-map]');
    var watchEl = root.querySelector('[data-watch-list]');
    var vetEl = root.querySelector('[data-vet-summary]');
    var flagsEl = root.querySelector('[data-red-flags]');
    var urgentEl = root.querySelector('[data-urgent]');
    var mobilityBridge = root.querySelector('[data-mobility-bridge]');
    var resetBtn = form.querySelector('[data-reset]');
    var errorEl = form.querySelector('[data-error]');

    function clearError() { errorEl.hidden = true; errorEl.textContent = ''; }
    function setError(msg) { errorEl.textContent = msg; errorEl.hidden = false; }
    function selectedFlags() {
      return Array.prototype.slice.call(form.querySelectorAll('input[name="redFlags"]:checked')).map(function (el) { return el.value; });
    }
    function addListItem(list, text) {
      var li = document.createElement('li');
      li.textContent = text;
      list.appendChild(li);
    }

    form.querySelectorAll('input[name="redFlags"]').forEach(function (input) {
      input.addEventListener('change', function () {
        var none = form.querySelector('input[data-none]');
        if (input === none && input.checked) {
          form.querySelectorAll('input[name="redFlags"]:not([data-none])').forEach(function (el) { el.checked = false; });
        } else if (input.checked && none) {
          none.checked = false;
        }
        if (selectedFlags().length === 0 && none) none.checked = true;
      });
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        form.reset();
        var none = form.querySelector('input[data-none]');
        if (none) none.checked = true;
        if (resultEl) resultEl.hidden = true;
        clearError();
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError();
      var scored = DOMAINS.map(function (domain) {
        var input = form.querySelector('input[name="' + domain.key + '"]:checked');
        return Object.assign({}, domain, { score: input ? parseInt(input.value, 10) : 0 });
      });
      if (scored.some(function (d) { return isNaN(d.score); })) {
        setError('Please answer each domain before creating the note.');
        return;
      }

      var raw = scored.reduce(function (sum, d) { return sum + d.score; }, 0);
      var signal = Math.round(100 - (raw / 28 * 100));
      var zone = zoneFor(signal);
      var flags = selectedFlags().filter(function (flag) { return flag !== 'None of these'; });

      scoreEl.textContent = signal;
      zoneEl.textContent = zone.name;
      interpEl.textContent = zone.text;
      urgentEl.hidden = flags.length === 0;

      mapEl.innerHTML = '';
      scored.forEach(function (d) {
        var row = document.createElement('div');
        row.className = 'wi-lens-row';
        row.innerHTML = '<span class="wi-lens-label"></span><span class="wi-lens-value"></span>';
        row.querySelector('.wi-lens-label').textContent = d.label + ' · ' + d.score + '/4';
        row.querySelector('.wi-lens-value').textContent = domainBand(d.score);
        mapEl.appendChild(row);
      });

      var top = scored.slice().sort(function (a, b) { return b.score - a.score; }).filter(function (d) { return d.score > 0; }).slice(0, 3);
      watchEl.innerHTML = '';
      if (top.length === 0) {
        addListItem(watchEl, 'No elevated domains today. Keep this as a baseline note.');
      } else {
        top.forEach(function (d) { addListItem(watchEl, d.label + ': ' + d.note); });
      }

      var topNames = top.map(function (d) { return d.label; });
      vetEl.textContent = topNames.length
        ? 'Top watch domains: ' + topNames.join(', ') + '. Bring the details above and note when each pattern started.'
        : 'Today’s answers are mostly stable. Bring this note as a baseline if you are tracking changes over time.';
      flagsEl.textContent = flags.length ? flags.join(', ') : 'None of these';
      if (mobilityBridge) mobilityBridge.hidden = !scored.some(function (d) { return d.key === 'mobility' && d.score >= 2; });

      resultEl.hidden = false;
      requestAnimationFrame(function () { resultEl.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    });
  }

  function ready() { document.querySelectorAll('[data-lpl-cat-qol]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-lpl-cat-qol]');
    if (root) init(root);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpl-diet-gap-check"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.lplInit === '1') return;
    root.dataset.lplInit = '1';
    var species = root.getAttribute('data-species') || 'dog';
    var form = root.querySelector('[data-lpl-form]');
    if (!form) return;

    var resultEl  = root.querySelector('[data-result]');
    var resetBtn  = form.querySelector('[data-reset]');
    var errEl     = form.querySelector('[data-error]');

    // ─── Conditional reveal of the recipe-detail step ──────────────────
    var homemadeStep = form.querySelector('[data-conditional="homemade"]');
    function refreshConditional() {
      var dt = (form.querySelector('input[name="mainDietType"]:checked') || {}).value;
      var nonComplete = parseInt((form.querySelector('input[name="nonCompletePct"]:checked') || {}).value || '0', 10);
      var shouldShow = ['home_cooked', 'homemade_raw', 'commercial_raw', 'mixed'].indexOf(dt) >= 0 || nonComplete >= 20;
      if (homemadeStep) homemadeStep.hidden = !shouldShow;
    }
    form.addEventListener('change', refreshConditional);
    refreshConditional();

    // ─── "Also feeds" multi-select: mutual exclusion with "None of the above" ──
    var afNoneEl = form.querySelector('input[name="alsoFeeds"][value="none"]');
    var afOtherEls = form.querySelectorAll('input[name="alsoFeeds"]:not([value="none"])');
    function handleAlsoFeedsChange(e) {
      if (e.target.name !== 'alsoFeeds') return;
      if (e.target.value === 'none') {
        // If "none" was just checked, uncheck everything else
        if (e.target.checked) {
          afOtherEls.forEach(function (el) { el.checked = false; });
        }
      } else {
        // If any other was just checked, uncheck "none"
        if (e.target.checked && afNoneEl) afNoneEl.checked = false;
      }
    }
    form.addEventListener('change', handleAlsoFeedsChange);

    // ─── Reset ────────────────────────────────────────────────────────
    if (resetBtn) resetBtn.addEventListener('click', function () {
      form.reset();
      refreshConditional();
      if (resultEl) resultEl.hidden = true;
      if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
    });

    // ─── Helpers ──────────────────────────────────────────────────────
    function val(name, dflt) {
      var el = form.querySelector('input[name="' + name + '"]:checked');
      return el ? el.value : (dflt == null ? '' : dflt);
    }
    function checked(name) {
      var el = form.querySelector('input[name="' + name + '"]');
      return !!(el && el.checked);
    }
    function intVal(name, dflt) {
      var v = val(name, '');
      var n = parseInt(v, 10);
      return isNaN(n) ? (dflt || 0) : n;
    }

    // ─── Rule engine ──────────────────────────────────────────────────
    function evaluate() {
      // Multi-select: "Also feeds regularly"
      var alsoFeedsEls = form.querySelectorAll('input[name="alsoFeeds"]:checked');
      var alsoFeeds = [];
      alsoFeedsEls.forEach(function (el) { if (el.value !== 'none') alsoFeeds.push(el.value); });

      var input = {
        species: species,
        lifeStage: val('lifeStage', 'adult'),
        bcs: val('bcs', 'ideal'),
        muscle: val('muscle', 'normal'),
        medical: val('medical', 'no'),
        prescription: val('prescription', 'no'),
        mainDietType: val('mainDietType', 'commercial_kibble'),
        alsoFeeds: alsoFeeds,
        hasAafco: val('hasAafco', 'unsure'),
        lifeStageMatch: val('lifeStageMatch', 'unsure'),
        treatsPct: intVal('treatsPct', 0),
        nonCompletePct: intVal('nonCompletePct', 0),
        recipeSource: val('recipeSource', 'unsure'),
        premix: val('premix', 'unsure'),
        calciumSource: val('calciumSource', 'unsure'),
        omega: val('omega', 'unsure'),
        dietPattern: val('dietPattern', 'none'),
        catPattern: val('catPattern', 'none'),
        catTaurine: val('catTaurine', 'unsure'),
        dosesKnown: val('dosesKnown', 'no'),
        supMulti: checked('supMulti'),
        supCalcium: checked('supCalcium'),
        supVitD: checked('supVitD'),
        supVitA: checked('supVitA'),
        supOmega: checked('supOmega'),
        supMultiple: checked('supMultiple'),
        signWeight: checked('signWeight'),
        signCoat: checked('signCoat'),
        signAppetite: checked('signAppetite'),
        signStool: checked('signStool'),
        signLethargy: checked('signLethargy'),
        signGrowth: checked('signGrowth'),
      };

      // Mixed-feeding notes (Module 6) — generated from alsoFeeds[]
      var mixedFeedNotes = [];
      var mn = function (s) { if (mixedFeedNotes.indexOf(s) < 0) mixedFeedNotes.push(s); };
      var afCount = alsoFeeds.length;
      if (afCount >= 3) mn('Three or more additional regular food categories were reported. Even when the primary diet is complete and balanced, this level of mixed feeding can materially erode the completeness guarantee.');
      else if (afCount === 2) mn('Two additional regular food categories were reported. This is normal but worth keeping under ~10–20% of daily calories so the primary diet does most of the nutritional work.');

      // Per-item notes
      if (alsoFeeds.indexOf('organ_meat') >= 0) {
        mn('Regular liver or organ meat: nutritionally rich but a known source of fat-soluble-vitamin (A, D) excess if frequency or portion size is high. Worth discussing dose with your vet.');
      }
      if (alsoFeeds.indexOf('raw_alongside') >= 0) {
        mn('Raw meat or organ alongside a commercial main: bacterial-safety practices and any premix/calcium planning for the raw portion are worth a vet conversation.');
      }
      if (alsoFeeds.indexOf('dairy') >= 0 && species === 'cat') {
        mn('Regular dairy in a cat diet can introduce GI sensitivity and adds calcium without adjusting phosphorus — usually a small effect, but worth noting.');
      }
      if (alsoFeeds.indexOf('cooked_additions') >= 0 && (input.treatsPct >= 20 || input.nonCompletePct >= 20)) {
        mn('Cooked human-food additions plus high treat/non-complete share means the primary diet may be doing less of the nutritional work than its label suggests.');
      }
      if (alsoFeeds.indexOf('broth') >= 0) {
        mn('Bone broth is generally low-risk; in larger volumes, consider whether added sodium or seasoning is present.');
      }

      var risk = 0;
      var drivers = [];
      var flags = [];
      function driver(p, s) { risk += p; if (drivers.indexOf(s) < 0) drivers.push(s); }
      function flag(f, p) { flags.push(f); risk += (p || 0); }

      // ── Baseline ─────────────────────────────────────────
      if (input.mainDietType === 'intermittent_supplemental_main') {
        driver(35, 'The main diet appears to be labeled for intermittent or supplemental feeding only, not complete daily nutrition.');
      }
      if (input.hasAafco === 'no') driver(20, 'No visible complete-and-balanced statement on the main diet.');
      else if (input.hasAafco === 'unsure') driver(10, 'Complete-and-balanced status of the main diet is unclear.');

      if (input.lifeStageMatch === 'no') driver(22, 'The label life stage does not match the pet&rsquo;s current life stage.');
      else if (input.lifeStageMatch === 'unsure') driver(8, 'Life-stage match is unclear.');

      if (input.lifeStage === 'puppy_kitten' || input.lifeStage === 'pregnant_lactating') {
        if (input.lifeStageMatch !== 'yes') {
          driver(18, 'Growth, pregnancy, or lactation increases the importance of life-stage-specific nutrition.');
        }
      }

      // ── Displacement ─────────────────────────────────────
      if (input.treatsPct > 25 || input.nonCompletePct > 25) {
        driver(20, 'A large share of calories appears to come from treats, toppers, or non-complete foods.');
      } else if (input.treatsPct > 10 || input.nonCompletePct > 10) {
        driver(10, 'Treats and non-complete foods may exceed the usual low-displacement range.');
      }

      // ── Home-prepared / raw ──────────────────────────────
      var homePrep = ['home_cooked', 'homemade_raw'].indexOf(input.mainDietType) >= 0;
      var rawishOrMixed = homePrep || input.mainDietType === 'commercial_raw' || input.mainDietType === 'mixed';

      if (homePrep && input.recipeSource !== 'vet_nutritionist') {
        driver(24, 'Home-prepared diets are most reliable when formulated or reviewed by a board-certified veterinary nutritionist.');
      }
      if (rawishOrMixed && input.premix !== 'yes') {
        driver(14, 'No clear vitamin-mineral premix reported for a home-prepared or raw-style diet.');
        flag({
          nutrient: 'zinc_copper_iron',
          label: 'Zinc / Copper / Iron',
          severity: 'discuss',
          reason: 'Home-prepared diets without a complete premix have trace-mineral uncertainty.',
          vetPrompt: 'Ask whether zinc, copper, iron, and other trace minerals are covered at appropriate levels.'
        }, 6);
        flag({
          nutrient: 'b_vitamins',
          label: 'B Vitamins',
          severity: 'discuss',
          reason: 'Without a complete micronutrient strategy, B-vitamin adequacy is worth reviewing.',
          vetPrompt: 'Ask whether B-vitamin coverage is complete for the recipe and feeding amount.'
        }, 4);
      }
      if (rawishOrMixed && (input.calciumSource === 'none' || input.calciumSource === 'unsure')) {
        var sev = input.lifeStage === 'puppy_kitten' ? 'vet_review' : 'discuss';
        flag({
          nutrient: 'calcium_phosphorus',
          label: 'Calcium / Phosphorus Balance',
          severity: sev,
          reason: 'Home-prepared or raw-style diets without a clear calcium source can create mineral-balance uncertainty — especially during growth.',
          vetPrompt: 'Ask your veterinarian whether the diet has an appropriate calcium source and Ca:P balance.'
        }, sev === 'vet_review' ? 22 : 14);
      }
      if (rawishOrMixed && input.omega !== 'yes') {
        flag({
          nutrient: 'essential_fatty_acids',
          label: 'Essential Fatty Acids',
          severity: 'discuss',
          reason: 'The diet pattern does not show a clear essential fatty-acid or omega-source strategy.',
          vetPrompt: 'Ask whether omega-6 and omega-3 fatty acid coverage is appropriate for the species and life stage.'
        }, 6);
      }

      // ── Species-specific ────────────────────────────────
      if (species === 'cat') {
        if (input.catPattern === 'uses_dog_food') driver(35, 'Dog food is not appropriate as a main diet for cats — cats have distinct nutrient requirements.');
        if (input.catPattern === 'vegetarian_vegan') driver(35, 'Vegetarian/vegan diets for cats require exceptional professional formulation and should be reviewed carefully.');
        if (input.catPattern === 'fish_majority') driver(14, 'A fish-majority diet can create thiamine and vitamin E imbalance over time.');

        var catFlagBase = (homePrep || input.catPattern !== 'none' || input.hasAafco !== 'yes');
        if (catFlagBase && input.catTaurine !== 'yes' && input.hasAafco !== 'yes') {
          flag({
            nutrient: 'taurine',
            label: 'Taurine',
            severity: 'vet_review',
            reason: 'This is a cat diet pattern without a clear complete-and-balanced source or visible taurine strategy.',
            vetPrompt: 'Ask your veterinarian to review taurine adequacy and whether the diet is appropriate for cats.'
          }, 22);
        }
        if (catFlagBase && input.hasAafco !== 'yes') {
          flag({
            nutrient: 'vitamin_a',
            label: 'Vitamin A',
            severity: 'vet_review',
            reason: 'This is a cat diet pattern without a visible complete-and-balanced statement or clear preformed vitamin A source.',
            vetPrompt: 'Ask whether the diet provides species-appropriate preformed vitamin A coverage.'
          }, 16);
          flag({
            nutrient: 'arachidonic_acid',
            label: 'Arachidonic Acid',
            severity: 'discuss',
            reason: 'Cats require dietary arachidonic acid; this pattern does not show a clear source.',
            vetPrompt: 'Ask whether the diet provides appropriate arachidonic acid coverage for cats.'
          }, 10);
        }
      } else {
        // dog
        if (input.dietPattern === 'meat_rice' && input.premix !== 'yes') {
          driver(18, 'A meat-and-rice-style homemade diet without a complete premix is commonly incomplete as a long-term diet.');
          flag({
            nutrient: 'calcium_phosphorus',
            label: 'Calcium / Phosphorus Balance',
            severity: 'vet_review',
            reason: 'Meat-heavy homemade diets without calcium planning create mineral-balance concerns.',
            vetPrompt: 'Ask whether the recipe has an appropriate calcium source and Ca:P balance.'
          }, 12);
        }
        if (input.dietPattern === 'vegetarian_vegan' && input.recipeSource !== 'vet_nutritionist') {
          driver(20, 'Vegetarian/vegan dog diets require careful formulation and should be professionally reviewed.');
          flag({
            nutrient: 'protein_amino_acids',
            label: 'Protein / Amino Acid Adequacy',
            severity: 'vet_review',
            reason: 'Plant-forward dog diets require careful amino-acid planning and cannot be assessed from ingredient names alone.',
            vetPrompt: 'Ask whether protein amount, digestibility, and amino-acid balance are appropriate.'
          }, 10);
        }
        if (input.dietPattern === 'large_breed_puppy' && input.lifeStageMatch !== 'yes') {
          driver(18, 'Large-breed puppies need especially careful growth nutrition and mineral balance.');
        }
      }

      // ── Supplement stacking ─────────────────────────────
      if (input.supVitD && input.dosesKnown !== 'yes') {
        flag({
          nutrient: 'vitamin_d',
          label: 'Vitamin D',
          severity: 'vet_review',
          reason: 'Vitamin D supplementation is in use but dose clarity is missing.',
          vetPrompt: 'Ask your veterinarian to review total vitamin D intake from food and supplements.'
        }, 12);
      }
      if (input.supVitA && input.dosesKnown !== 'yes') {
        flag({
          nutrient: 'vitamin_a',
          label: 'Vitamin A',
          severity: 'vet_review',
          reason: 'Vitamin A or cod liver oil is in use but dose clarity is missing.',
          vetPrompt: 'Ask your veterinarian to review total vitamin A intake and cumulative fat-soluble vitamin exposure.'
        }, 12);
      }
      if (input.supCalcium && input.dosesKnown !== 'yes') {
        flag({
          nutrient: 'calcium_phosphorus',
          label: 'Calcium / Phosphorus Balance',
          severity: 'vet_review',
          reason: 'Calcium supplementation is in use but dose clarity is missing.',
          vetPrompt: 'Ask whether calcium dose and Ca:P balance are appropriate for the diet and life stage.'
        }, 10);
      }
      if (input.supMultiple && input.dosesKnown !== 'yes') {
        driver(10, 'Multiple supplements are in use but dose information is incomplete, increasing stacking uncertainty.');
      }

      // ── Body / muscle / medical / signs ─────────────────
      // bcs values map to BC tool categories: under, lean, ideal, above, sig (1-5 scale).
      // Trigger calorie/body-condition flag when outside the ideal middle.
      if (['under', 'above', 'sig'].indexOf(input.bcs) >= 0) {
        driver(10, 'Body condition is outside the ideal range, suggesting calorie balance and feeding plan should be reviewed.');
        flag({
          nutrient: 'calorie_body_condition',
          label: 'Calorie Balance / Body Condition',
          severity: input.bcs === 'sig' ? 'vet_review' : 'discuss',
          reason: 'Body condition is outside the ideal middle range.',
          vetPrompt: 'Ask whether feeding amount, calorie density, and treat intake match the pet&rsquo;s ideal body condition.'
        }, input.bcs === 'sig' ? 10 : 6);
      }
      if (input.muscle === 'moderate_loss' || input.muscle === 'severe_loss') {
        driver(15, 'Muscle loss was reported — should be reviewed by a veterinarian.');
        flag({
          nutrient: 'protein_amino_acids',
          label: 'Protein / Amino Acid Adequacy',
          severity: 'vet_review',
          reason: 'Muscle loss can reflect many causes; diet protein quality may be part of the review.',
          vetPrompt: 'Ask whether protein intake, digestibility, and health status should be evaluated together.'
        }, 10);
      }
      if (input.medical === 'yes' || input.prescription === 'yes') {
        driver(15, 'A medical condition or prescription diet was reported — diet changes should be reviewed with the veterinary team.');
      }

      var signCount = ['signWeight','signCoat','signAppetite','signStool','signLethargy','signGrowth'].reduce(function (n, k) { return n + (input[k] ? 1 : 0); }, 0);
      if (signCount >= 2) driver(12, 'Multiple recent changes were reported — appetite/coat/stool/weight shifts deserve a vet conversation.');

      // ── Grade ───────────────────────────────────────────
      var grade = 'A';
      if (risk >= 75) grade = 'VET_REVIEW';
      else if (risk >= 50) grade = 'D';
      else if (risk >= 28) grade = 'C';
      else if (risk >= 12) grade = 'B';

      var labels = {
        A: 'Baseline Likely Covered',
        B: 'Mostly Covered, Some Uncertainty',
        C: 'Moderate Diet-Completeness Uncertainty',
        D: 'Higher Risk Of Nutrient Imbalance',
        VET_REVIEW: 'Vet Nutrition Review Recommended'
      };

      var summary = {
        A: 'Based on what you reported, baseline nutrition looks likely covered. This does not automatically answer higher-order questions like ingredient transparency, omega balance, healthy-aging support, or cellular resilience.',
        B: 'Baseline nutrition may be mostly covered, with one or two uncertainty points worth reviewing — life-stage match, treat displacement, supplement stacking, or label clarity.',
        C: 'This diet pattern shows moderate diet-completeness uncertainty. Reasonable to bring the labels, treats, and supplement bottles to your veterinarian for review.',
        D: 'This diet pattern shows higher risk of nutrient imbalance or incomplete coverage. Professional review is recommended before relying on this diet long-term.',
        VET_REVIEW: 'This diet pattern warrants veterinary nutrition review — especially given growth, pregnancy/lactation, medical complexity, home-prepared/raw/restricted diet, or reported body-condition changes.'
      }[grade];

      // ── Above-Baseline Support Signals (Concept B, GPT-tuned bands) ──
      // Bands: Strong / Moderate / Limited / Not Clearly Visible — no A-F.
      // This is a visibility/support lens. Not a medical or adequacy score.
      // Default state: "Limited" (most diets — AAFCO doesn't measure these things).
      // Upgrade only when explicit positive signals show up.
      var signalsPoints = 0;
      var pathwayNotes = [];
      // + signals
      if (input.mainDietType === 'commercial_fresh' || input.mainDietType === 'home_cooked') {
        signalsPoints += 1; pathwayNotes.push('whole-food / less-processed primary');
      }
      if (input.omega === 'yes' || input.supOmega) {
        signalsPoints += 1; pathwayNotes.push('omega-3 source identified');
      }
      if (input.lifeStageMatch === 'yes' && (input.lifeStage === 'senior' || input.lifeStage === 'puppy_kitten' || input.lifeStage === 'pregnant_lactating')) {
        signalsPoints += 1; pathwayNotes.push('life-stage-matched diet');
      }
      // − signals (soft, no harsh kibble-shaming)
      if (input.omega !== 'yes' && !input.supOmega) {
        signalsPoints -= 0.5;
      }
      if (['under', 'above', 'sig'].indexOf(input.bcs) >= 0) {
        signalsPoints -= 0.5;
      }
      if (input.lifeStage === 'senior' && input.lifeStageMatch !== 'yes') {
        signalsPoints -= 0.5;
      }
      // Visibility check — if too many "unsure" answers, signal isn't measurable
      var unsureCount = 0;
      ['hasAafco','lifeStageMatch','recipeSource','premix','calciumSource','omega'].forEach(function (k) {
        if (input[k] === 'unsure') unsureCount += 1;
      });

      var signalsBand, signalsLabel, signalsDesc;
      if (unsureCount >= 4) {
        signalsBand = 'Not Clearly Visible';
        signalsLabel = 'Not Clearly Visible';
        signalsDesc = 'Not enough information was provided to read above-baseline support signals. Add product label and recipe details to see this lens.';
      } else if (signalsPoints >= 2) {
        signalsBand = 'Strong';
        signalsLabel = 'Strong Signals';
        signalsDesc = 'The diet pattern shows multiple visible above-baseline signals (whole-food primary, omega coverage, life-stage match). This is rare and worth noting.';
      } else if (signalsPoints >= 1) {
        signalsBand = 'Moderate';
        signalsLabel = 'Moderate Signals';
        signalsDesc = 'At least one above-baseline support signal is visible from the diet pattern. Pathway-level support is partially addressed by food alone.';
      } else {
        signalsBand = 'Limited';
        signalsLabel = 'Limited Signals';
        signalsDesc = 'Above-baseline support is not clearly visible from the diet pattern alone — which is typical. Most pet foods are not formulated for healthy-aging, antioxidant defense, or recovery pathways; those are separate questions.';
      }

      // ── Lens dimensions (Module 3) — supports the two scores ──
      var lens = {
        transparency:
          input.hasAafco === 'yes' && input.lifeStageMatch === 'yes' ? 'Strong' :
          input.hasAafco === 'unsure' || input.lifeStageMatch === 'unsure' ? 'Moderate' : 'Weak',
        lifestage:
          input.lifeStageMatch === 'yes' ? 'Clear' :
          input.lifeStageMatch === 'unsure' ? 'Uncertain' : 'Mismatch',
        displacement:
          (input.treatsPct <= 10 && input.nonCompletePct <= 10 && afCount <= 1) ? 'Good' :
          (input.treatsPct <= 25 && input.nonCompletePct <= 25 && afCount <= 2) ? 'Moderate' : 'High displacement',
        stacking:
          (input.supMultiple && input.dosesKnown !== 'yes') ? 'High' :
          (input.supCalcium || input.supVitD || input.supVitA) ? 'Moderate' : 'Low',
        pathway: signalsBand
      };

      // Apply afCount as displacement modifier on baseline grade
      if (afCount >= 3 && grade === 'A') {
        // Three+ regular extras erodes confidence even if AAFCO is yes
        grade = 'B';
      }

      // ── Dedupe nutrient flags (keep highest severity per nutrient) ──
      var sevRank = { vet_review: 3, discuss: 2, watch: 1 };
      var byNutrient = {};
      flags.forEach(function (f) {
        var ex = byNutrient[f.nutrient];
        if (!ex || sevRank[f.severity] > sevRank[ex.severity]) byNutrient[f.nutrient] = f;
      });
      var dedupedFlags = Object.keys(byNutrient).map(function (k) { return byNutrient[k]; });

      // ── Vet handoff ─────────────────────────────────────
      var handoff = [
        'Species: ' + species,
        'Life stage: ' + input.lifeStage.replace('_', ' / '),
        'Main diet: ' + input.mainDietType.replace(/_/g, ' '),
        'Complete-and-balanced statement: ' + input.hasAafco,
        'Label life-stage match: ' + input.lifeStageMatch,
        'Treats / toppers / scraps share: ' + input.treatsPct + '% of calories',
        'Non-complete foods share: ' + input.nonCompletePct + '% of calories',
        'Result: ' + labels[grade]
      ];
      if (drivers.length) handoff.push('Risk drivers: ' + drivers.slice(0, 6).join('; '));
      if (dedupedFlags.length) handoff.push('Nutrient topics to discuss: ' + dedupedFlags.map(function (f) { return f.label; }).join(', '));
      handoff.push('Bring to the visit: product label, feeding amount, treat/topper list, supplement bottles with doses if known, and any homemade recipe.');

      return {
        grade: grade,
        gradeLabel: labels[grade],
        summary: summary,
        drivers: drivers.slice(0, 6),
        flags: dedupedFlags,
        lens: lens,
        handoff: handoff,
        signalsBand: signalsBand,
        signalsLabel: signalsLabel,
        signalsDesc: signalsDesc,
        mixedFeedNotes: mixedFeedNotes
      };
    }

    // ─── Render result ────────────────────────────────────────────────
    function render(out) {
      root.querySelector('[data-grade-letter]').textContent = out.grade === 'VET_REVIEW' ? '!' : out.grade;
      root.querySelector('[data-grade-label]').textContent = out.gradeLabel;
      root.querySelector('[data-summary]').textContent = out.summary;

      // Above-Baseline Support Signals (Module 2 — second score)
      var sigEl = root.querySelector('[data-signals-band]');
      var sigLabelEl = root.querySelector('[data-signals-label]');
      if (sigEl) {
        sigEl.textContent = out.signalsBand;
        sigEl.setAttribute('data-band', out.signalsBand.toLowerCase().replace(/[^a-z]+/g, '-'));
      }
      if (sigLabelEl) sigLabelEl.textContent = out.signalsLabel;
      // Replace the static .wi-score--signals description with the dynamic one
      var sigDescEl = root.querySelector('.wi-score--signals .wi-score-desc');
      if (sigDescEl) sigDescEl.textContent = out.signalsDesc;

      // Lens
      root.querySelector('[data-lens-transparency]').textContent = out.lens.transparency;
      root.querySelector('[data-lens-lifestage]').textContent = out.lens.lifestage;
      root.querySelector('[data-lens-displacement]').textContent = out.lens.displacement;
      root.querySelector('[data-lens-stacking]').textContent = out.lens.stacking;
      var lensPathwayEl = root.querySelector('[data-lens-pathway]');
      if (lensPathwayEl) lensPathwayEl.textContent = out.lens.pathway;

      // Mixed-feeding notes (Module 6)
      var mfSection = root.querySelector('[data-mixedfeed-section]');
      var mfList = root.querySelector('[data-mixedfeed-notes]');
      if (mfList) mfList.innerHTML = '';
      if (mfSection) {
        if (out.mixedFeedNotes && out.mixedFeedNotes.length) {
          out.mixedFeedNotes.forEach(function (n) {
            var li = document.createElement('li');
            li.textContent = n;
            mfList.appendChild(li);
          });
          mfSection.hidden = false;
        } else {
          mfSection.hidden = true;
        }
      }

      // Risk drivers
      var rdEl = root.querySelector('[data-risk-drivers]');
      rdEl.innerHTML = '';
      if (!out.drivers.length) {
        var li = document.createElement('li');
        li.textContent = 'No significant risk drivers detected from the information provided.';
        rdEl.appendChild(li);
      } else {
        out.drivers.forEach(function (d) {
          var li = document.createElement('li');
          li.innerHTML = d;
          rdEl.appendChild(li);
        });
      }

      // Nutrient flags
      var nfEl = root.querySelector('[data-nutrient-flags]');
      nfEl.innerHTML = '';
      if (!out.flags.length) {
        var p = document.createElement('p');
        p.style.fontSize = '13.5px'; p.style.color = 'rgba(19,18,17,0.7)';
        p.textContent = 'No specific nutrient-discussion topics surfaced from your inputs. Still bring the diet details to your annual veterinary visit — that conversation is its own value.';
        nfEl.appendChild(p);
      } else {
        out.flags.forEach(function (f) {
          var card = document.createElement('div');
          card.className = 'wi-nutrient-card sev-' + f.severity;
          card.innerHTML =
            '<div class="wi-nutrient-card-head">' +
              '<span class="wi-nutrient-label">' + f.label + '</span>' +
              '<span class="wi-nutrient-sev">' + (f.severity === 'vet_review' ? 'Vet review' : 'Discuss') + '</span>' +
            '</div>' +
            '<p class="wi-nutrient-reason">' + f.reason + '</p>' +
            '<p class="wi-nutrient-ask"><strong>Ask your vet:</strong> ' + f.vetPrompt + '</p>';
          nfEl.appendChild(card);
        });
      }

      // Vet handoff
      var hoEl = root.querySelector('[data-vet-handoff]');
      hoEl.innerHTML = '';
      out.handoff.forEach(function (h) {
        var li = document.createElement('li');
        li.textContent = h;
        hoEl.appendChild(li);
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
      var out = evaluate();
      render(out);
      resultEl.hidden = false;
      requestAnimationFrame(function () { resultEl.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    });
  }

  function ready() { document.querySelectorAll('[data-lpl-dg]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-lpl-dg]');
    if (root) init(root);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpl-hydration-calculator"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Base water requirement: ~50 ml per kg per day (≈ 1 oz per lb).
  var BASE_ML_PER_KG = 50;

  // Age-stage adjustments (growing animals need more relative to size).
  var AGE_ADJ = {
    puppy:  1.15,
    kitten: 1.15,
    adult:  1.00,
    senior: 1.00
  };

  // Activity adjustments.
  var ACTIVITY_ADJ = { low: 1.0, moderate: 1.1, high: 1.25 };

  // Climate adjustments.
  var CLIMATE_ADJ = { temperate: 1.0, hot: 1.3 };

  // Food moisture share of daily water (fraction provided by food).
  var FOOD_WATER_SHARE = {
    dry:   0.05,
    mixed: 0.30,
    wet:   0.55
  };

  var FOOD_MOISTURE_COPY = {
    dry:   'Dry kibble contains about 10% moisture. On a primarily dry diet, your pet needs to drink nearly all of their daily water from the bowl. Multiple fresh water stations help keep intake steady.',
    mixed: 'A mixed diet of wet and dry food provides moderate water from meals — typically around a quarter to a third of daily needs. The rest should come from drinking.',
    wet:   'Wet food is about 70–80% moisture and can provide roughly half of daily water needs. Pets on primarily wet diets often drink noticeably less from the bowl — this is generally normal, not concerning.'
  };

  var HEALTHY_SIGNS = [
    'Moist, pink gums that refill color quickly when gently pressed',
    'Skin that returns to position promptly when gently lifted at the shoulders',
    'Bright, alert eyes and steady energy through the day',
    'Regular urination — typical color, typical frequency'
  ];

  var MONITOR_SIGNS = {
    dog: [
      'Drinking noticeably more or less than usual for several days',
      'Dry, tacky gums or sunken-looking eyes',
      'Lethargy, reduced appetite, or unusual sleepiness',
      'Vomiting, diarrhea, or known fluid loss',
      'Skin that returns slowly when gently lifted'
    ],
    cat: [
      'Drinking noticeably more or less than usual for several days',
      'Dry, tacky gums or sunken-looking eyes',
      'Lethargy, hiding, or unusual sleepiness',
      'Vomiting, diarrhea, or known fluid loss',
      'Reduced urination or changes in litter-box habits'
    ]
  };

  var TIPS = {
    dog: {
      general: [
        'Provide fresh water in clean bowls, refilled at least daily',
        'Place multiple water stations around the home, especially on different floors',
        'Offer cool (not ice-cold) water after activity or in heat',
        'Consider adding wet food or a splash of low-sodium broth to dry meals if drinking is low',
        'Bring water on walks and longer outings, especially in warm weather'
      ],
      senior: [
        'Place water stations near rest spots so a senior dog doesn\'t have to travel far',
        'Use shallow, wide bowls — easier for stiff necks',
        'Refresh water more often; older dogs are often more sensitive to taste and smell',
        'Consider adding wet food or warm-water-softened kibble to support steady moisture intake',
        'Watch trends over weeks, not days — gradual changes in drinking are easy to miss'
      ]
    },
    cat: {
      general: [
        'Place water bowls away from food bowls — cats often prefer the separation',
        'Use wide, shallow ceramic or glass bowls; many cats dislike narrow bowls that touch their whiskers',
        'Offer multiple water stations, especially in larger homes or multi-cat households',
        'Consider a pet fountain — many cats prefer moving water',
        'Including some wet food in the diet supports steady hydration for low-thirst-drive cats'
      ],
      senior: [
        'Place water stations near favorite rest spots and on every floor a senior cat uses',
        'Use wide, shallow bowls — easier for older cats with stiffer necks',
        'Refresh water more often; senior cats are often more sensitive to taste and smell',
        'A pet fountain can encourage drinking if a senior cat starts visiting the bowl less',
        'Watch trends over weeks, not days — gradual changes in drinking are easy to miss'
      ]
    }
  };

  function mlToCups(ml) { return ml / 240; }
  function mlToFlOz(ml) { return ml / 29.5735; }

  function roundCups(c) {
    // Round to nearest 0.25 cup
    return Math.round(c * 4) / 4;
  }

  function init(root) {
    if (root.dataset.lplInit === '1') return;
    root.dataset.lplInit = '1';

    var species = root.getAttribute('data-species') || 'dog';
    var form = root.querySelector('[data-lpl-form]');
    if (!form) return;

    var weightEl   = form.querySelector('[data-field="weight"]');
    var errorEl    = form.querySelector('[data-error]');
    var resetBtn   = form.querySelector('[data-reset]');
    var resultEl   = root.querySelector('[data-result]');
    var cupsEl     = root.querySelector('[data-result-cups]');
    var metaEl     = root.querySelector('[data-result-meta]');
    var rangeEl    = root.querySelector('[data-result-range]');
    var bandMarker = root.querySelector('[data-band-marker]');
    var bandSpan   = root.querySelector('[data-band-span]');
    var foodSplitEl   = root.querySelector('[data-food-split]');
    var foodMoistureEl = root.querySelector('[data-food-moisture]');
    var healthyEl  = root.querySelector('[data-healthy]');
    var monitorEl  = root.querySelector('[data-monitor]');
    var tipsEl     = root.querySelector('[data-tips]');
    var tipsHEl    = root.querySelector('[data-tips-h]');

    function clearError() { errorEl.hidden = true; errorEl.textContent = ''; }
    function setError(msg) { errorEl.textContent = msg; errorEl.hidden = false; }

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        form.reset();
        if (resultEl) resultEl.hidden = true;
        clearError();
      });
    }

    function fillList(el, items) {
      el.innerHTML = '';
      items.forEach(function (item) {
        var li = document.createElement('li');
        li.textContent = item;
        el.appendChild(li);
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError();

      var weight = parseFloat(weightEl.value);
      if (isNaN(weight) || weight <= 0) { setError('Please enter your ' + species + '\'s weight.'); return; }

      var unitInput = form.querySelector('input[name="unit"]:checked');
      var unit = unitInput ? unitInput.value : 'lb';
      var weightKg = unit === 'kg' ? weight : weight / 2.20462;

      var maxKg = species === 'dog' ? 110 : 15;
      if (weightKg > maxKg) { setError('Please enter a realistic weight.'); return; }
      if (weightKg < 0.2)   { setError('Please enter a realistic weight.'); return; }

      var age      = (form.querySelector('input[name="age"]:checked') || {}).value || 'adult';
      var diet     = (form.querySelector('input[name="diet"]:checked') || {}).value || 'dry';
      var activity = (form.querySelector('input[name="activity"]:checked') || {}).value || 'moderate';
      var climate  = (form.querySelector('input[name="climate"]:checked') || {}).value || 'temperate';

      var totalMl = weightKg * BASE_ML_PER_KG;
      totalMl *= (AGE_ADJ[age] || 1.0);
      totalMl *= (ACTIVITY_ADJ[activity] || 1.0);
      totalMl *= (CLIMATE_ADJ[climate] || 1.0);

      var fromFoodMl = totalMl * (FOOD_WATER_SHARE[diet] || 0.05);
      var fromBowlMl = totalMl - fromFoodMl;

      var totalCups = roundCups(mlToCups(totalMl));
      var lowCups   = roundCups(mlToCups(totalMl * 0.9));
      var highCups  = roundCups(mlToCups(totalMl * 1.1));
      var totalOz   = Math.round(mlToFlOz(totalMl));
      var totalMlRounded = Math.round(totalMl / 10) * 10;

      var bowlCups = roundCups(mlToCups(fromBowlMl));
      var foodCups = roundCups(mlToCups(fromFoodMl));

      cupsEl.textContent = totalCups.toFixed(2).replace(/\.?0+$/, '');
      metaEl.textContent = '≈ ' + totalOz + ' fl oz · ' + totalMlRounded + ' ml per day (total water need, including food)';
      rangeEl.textContent = 'Typical range: ' + lowCups + '–' + highCups + ' cups / day';

      // Range band: dogs 0–12 cups, cats 0–4 cups.
      if (bandMarker && bandSpan) {
        var domHi = species === 'cat' ? 4 : 12;
        var clampPct = function (v) {
          return Math.max(0, Math.min(100, v / domHi * 100));
        };
        bandMarker.style.left = clampPct(totalCups) + '%';
        var lp = clampPct(lowCups), hp = clampPct(highCups);
        bandSpan.style.left = lp + '%';
        bandSpan.style.width = (hp - lp) + '%';
      }

      foodSplitEl.textContent =
        'About ' + bowlCups + ' cups from drinking water and ~' + foodCups + ' cups from food. ' +
        'These are estimates — actual contribution from food depends on diet composition and serving size.';

      foodMoistureEl.textContent = FOOD_MOISTURE_COPY[diet] || FOOD_MOISTURE_COPY.dry;

      fillList(healthyEl, HEALTHY_SIGNS);
      fillList(monitorEl, MONITOR_SIGNS[species]);

      if (age === 'senior') {
        tipsHEl.textContent = 'Hydration tips for senior pets';
        fillList(tipsEl, TIPS[species].senior);
      } else {
        tipsHEl.textContent = 'Everyday hydration tips';
        fillList(tipsEl, TIPS[species].general);
      }

      resultEl.hidden = false;
      requestAnimationFrame(function () {
        resultEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function ready() {
    document.querySelectorAll('[data-lpl-hc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-lpl-hc]');
    if (root) init(root);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpl-life-stage-framework"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.lplInit === '1') return;
    root.dataset.lplInit = '1';

    var rail = root.querySelector('.lpl-ls-rail');
    if (!rail) return;
    var buttons = rail.querySelectorAll('.lpl-ls-railbtn');
    var panels = root.querySelectorAll('.lpl-ls-panel');

    function activate(stage) {
      buttons.forEach(function (b) {
        var active = b.getAttribute('data-stage') === stage;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var active = p.getAttribute('data-panel') === stage;
        p.classList.toggle('is-active', active);
        if (active) {
          p.removeAttribute('hidden');
        } else {
          p.setAttribute('hidden', '');
        }
      });
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        activate(b.getAttribute('data-stage'));
      });
    });

    // Keyboard navigation across tabs
    rail.addEventListener('keydown', function (e) {
      var current = document.activeElement;
      if (!current || !current.classList || !current.classList.contains('lpl-ls-railbtn')) return;
      var list = Array.prototype.slice.call(buttons);
      var idx = list.indexOf(current);
      if (idx < 0) return;
      var next = null;
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next = list[(idx + 1) % list.length];
      else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') next = list[(idx - 1 + list.length) % list.length];
      else if (e.key === 'Home') next = list[0];
      else if (e.key === 'End') next = list[list.length - 1];
      if (next) {
        e.preventDefault();
        next.focus();
        activate(next.getAttribute('data-stage'));
      }
    });

    // Optional: support deep-linking via hash (e.g. #stage=senior)
    var hash = window.location.hash || '';
    var m = hash.match(/stage=([a-z]+)/i);
    if (m && m[1]) {
      var requested = m[1].toLowerCase();
      var exists = Array.prototype.some.call(buttons, function (b) {
        return b.getAttribute('data-stage') === requested;
      });
      if (exists) activate(requested);
    }
  }

  function ready() {
    document.querySelectorAll('[data-lpl-ls]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-lpl-ls]');
    if (root) init(root);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpl-quality-of-life-scale"] && !Shopify.designMode) return;
  try {
    
(function () {
  var DOMAINS = [
    { key: 'comfort', label: 'Comfort', note: 'Comfort signals are strongest when you can describe timing, triggers, and recovery after rest.' },
    { key: 'appetite', label: 'Appetite', note: 'Appetite and weight trends are useful to bring with dates, food amounts, and any vomiting notes.' },
    { key: 'hydration', label: 'Hydration/elimination', note: 'Drinking and bathroom changes are clearer when tracked as daily patterns, not one-off moments.' },
    { key: 'hygiene', label: 'Hygiene', note: 'Coat, skin, odor, matting, and cleanliness changes can affect comfort and daily function.' },
    { key: 'mobility', label: 'Mobility', note: 'Mobility is easiest to discuss with short videos of rising, stairs, walking, and turning.' },
    { key: 'engagement', label: 'Engagement', note: 'Engagement includes interest in family, routines, food, play, sniffing, and familiar comforts.' },
    { key: 'gooddays', label: 'Good-day pattern', note: 'Good-day versus difficult-day patterns help your veterinarian understand the trend over time.' }
  ];

  function domainBand(score) {
    if (score <= 1) return 'Low';
    if (score === 2) return 'Watch';
    if (score === 3) return 'Discuss';
    return 'Urgent';
  }

  function zoneFor(signal) {
    if (signal >= 85) return {
      name: 'Stable / strong daily-life signal',
      text: 'Your answers describe a strong daily-life pattern today. Keep tracking the domains that matter most so changes are easy to see early.'
    };
    if (signal >= 70) return {
      name: 'Generally good, watch specific domains',
      text: 'Your dog’s overall signal is generally good, with a few domains worth watching. Save this note and repeat it to see whether those areas settle or trend upward.'
    };
    if (signal >= 50) return {
      name: 'Mixed signal; useful to discuss with veterinarian',
      text: 'The pattern is mixed. This is a useful time to bring a concise note to your veterinarian, especially around the highest-scoring domains.'
    };
    if (signal >= 30) return {
      name: 'Concerning signal; schedule veterinary review',
      text: 'Several daily-life domains are carrying concern. Schedule a veterinary review and bring examples, videos, and recent changes.'
    };
    return {
      name: 'Serious concern; prompt veterinary guidance',
      text: 'The answers suggest a serious daily-life concern. Please seek prompt veterinary guidance, especially if the pattern is new or worsening.'
    };
  }

  function init(root) {
    if (root.dataset.lplInit === '1') return;
    root.dataset.lplInit = '1';

    var form = root.querySelector('[data-lpl-form]');
    if (!form) return;

    var resultEl = root.querySelector('[data-result]');
    var scoreEl = root.querySelector('[data-score]');
    var zoneEl = root.querySelector('[data-zone]');
    var interpEl = root.querySelector('[data-interpretation]');
    var mapEl = root.querySelector('[data-domain-map]');
    var watchEl = root.querySelector('[data-watch-list]');
    var vetEl = root.querySelector('[data-vet-summary]');
    var flagsEl = root.querySelector('[data-red-flags]');
    var urgentEl = root.querySelector('[data-urgent]');
    var mobilityBridge = root.querySelector('[data-mobility-bridge]');
    var resetBtn = form.querySelector('[data-reset]');
    var errorEl = form.querySelector('[data-error]');

    function clearError() { errorEl.hidden = true; errorEl.textContent = ''; }
    function setError(msg) { errorEl.textContent = msg; errorEl.hidden = false; }

    function selectedFlags() {
      return Array.prototype.slice.call(form.querySelectorAll('input[name="redFlags"]:checked')).map(function (el) {
        return el.value;
      });
    }

    form.querySelectorAll('input[name="redFlags"]').forEach(function (input) {
      input.addEventListener('change', function () {
        var none = form.querySelector('input[data-none]');
        if (input === none && input.checked) {
          form.querySelectorAll('input[name="redFlags"]:not([data-none])').forEach(function (el) { el.checked = false; });
        } else if (input.checked && none) {
          none.checked = false;
        }
        if (selectedFlags().length === 0 && none) none.checked = true;
      });
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        form.reset();
        var none = form.querySelector('input[data-none]');
        if (none) none.checked = true;
        if (resultEl) resultEl.hidden = true;
        clearError();
      });
    }

    function addListItem(list, text) {
      var li = document.createElement('li');
      li.textContent = text;
      list.appendChild(li);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError();

      var scored = DOMAINS.map(function (domain) {
        var input = form.querySelector('input[name="' + domain.key + '"]:checked');
        return Object.assign({}, domain, { score: input ? parseInt(input.value, 10) : 0 });
      });
      if (scored.some(function (d) { return isNaN(d.score); })) {
        setError('Please answer each domain before creating the note.');
        return;
      }

      var raw = scored.reduce(function (sum, d) { return sum + d.score; }, 0);
      var signal = Math.round(100 - (raw / 28 * 100));
      var zone = zoneFor(signal);
      var flags = selectedFlags().filter(function (flag) { return flag !== 'None of these'; });

      scoreEl.textContent = signal;
      zoneEl.textContent = zone.name;
      interpEl.textContent = zone.text;
      urgentEl.hidden = flags.length === 0;

      mapEl.innerHTML = '';
      scored.forEach(function (d) {
        var row = document.createElement('div');
        row.className = 'wi-lens-row';
        row.innerHTML = '<span class="wi-lens-label"></span><span class="wi-lens-value"></span>';
        row.querySelector('.wi-lens-label').textContent = d.label + ' · ' + d.score + '/4';
        row.querySelector('.wi-lens-value').textContent = domainBand(d.score);
        mapEl.appendChild(row);
      });

      var top = scored.slice().sort(function (a, b) { return b.score - a.score; }).filter(function (d) { return d.score > 0; }).slice(0, 3);
      watchEl.innerHTML = '';
      if (top.length === 0) {
        addListItem(watchEl, 'No elevated domains today. Keep this as a baseline note.');
      } else {
        top.forEach(function (d) { addListItem(watchEl, d.label + ': ' + d.note); });
      }

      var topNames = top.map(function (d) { return d.label; });
      vetEl.textContent = topNames.length
        ? 'Top watch domains: ' + topNames.join(', ') + '. Bring the details above and note when each pattern started.'
        : 'Today’s answers are mostly stable. Bring this note as a baseline if you are tracking changes over time.';
      flagsEl.textContent = flags.length ? flags.join(', ') : 'None of these';
      if (mobilityBridge) mobilityBridge.hidden = !scored.some(function (d) { return d.key === 'mobility' && d.score >= 2; });

      resultEl.hidden = false;
      requestAnimationFrame(function () {
        resultEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function ready() {
    document.querySelectorAll('[data-lpl-qol]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-lpl-qol]');
    if (root) init(root);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpl-sleep-calculator"] && !Shopify.designMode) return;
  try {
    
(function () {
  var BASE_RANGE = {
    dog: { puppy:[18,20], adult:[12,14], senior:[14,16] },
    cat: { kitten:[18,20], adult:[12,16], senior:[15,18] }
  };
  var DOG_SIZE_ADJ = { small:[-1,0], medium:[0,0], large:[0,1], giant:[1,2] };
  var ACTIVITY_ADJ = { low:[1,1], moderate:[0,0], high:[-1,-1] };
  var DOG_LIFESTYLE_ADJ = { companion:[0,0], working:[-1,0] };
  var CAT_LIFESTYLE_ADJ = { indoor:[1,1], outdoor:[0,0] };
  var ADVANCED_ADJ = [2,2];

  var INTERP = {
    dog: {
      puppy:  'Puppies sleep more than any other life stage. Growth, neurological development, and learning all consolidate during deep rest. A puppy that sleeps most of the day, then bursts into intense play, is following normal biology.',
      adult:  'Adult dogs settle into a steady rhythm — deep night sleep with several daytime rest periods. The pattern matters as much as the total hours.',
      senior: 'Senior dogs typically sleep more than they did in their adult years. Recovery takes longer, and rest is increasingly restorative. A gradual increase over months is usually normal aging.'
    },
    cat: {
      kitten: 'Kittens sleep more than any other feline life stage. Growth, neurological development, and learning all consolidate during deep rest. A kitten that sleeps most of the day, then bursts into intense play, is following normal biology.',
      adult:  'Adult cats settle into the classic feline rhythm — short alert bursts and long recovery periods, with deep night sleep and frequent daytime naps.',
      senior: 'Senior cats typically sleep more than they did in their adult years. Stillness becomes more restorative, and recovery takes longer. A gradual increase over months is usually normal aging.'
    }
  };
  var NORMAL_COPY = {
    dog: {
      puppy:  'Yes — this range is typical for a puppy. Sleep is the time when growth and learning consolidate, so high totals are healthy and expected.',
      adult:  'Yes — this range is typical for a healthy adult dog. Look more at the pattern than the total. Easy waking, smooth movement, and engaged play between rests are the signals that matter most.',
      senior: 'Yes — this range is typical for a senior dog. Gradual increases in sleep over months are part of normal aging. Sudden changes, or sleep changes paired with pain or appetite shifts, are worth a closer look.'
    },
    cat: {
      kitten: 'Yes — this range is typical for a kitten. Sleep is the time when growth and learning consolidate, so high totals are healthy and expected.',
      adult:  'Yes — this range is typical for a healthy adult cat. Cats are biologically built for layered rest: easy waking, deep stretches, and brief grooming sessions between sleeps are the signals that matter most.',
      senior: 'Yes — this range is typical for a senior cat. Gradual increases in sleep over months are part of normal aging. Sudden changes, or sleep changes paired with hiding or appetite shifts, are worth a closer look.'
    }
  };
  var AGE_CHANGE_COPY = {
    dog: 'Sleep generally increases with age in dogs. Recovery takes longer, sensory input is more tiring, and the body uses rest to repair more deliberately. This is biologically coherent — not a problem to solve. The shift in pattern matters more than the total.',
    cat: 'Sleep generally increases with age in cats. Stillness becomes more restorative, joints prefer rest, and the body uses sleep to repair more deliberately. This is biologically coherent — not a problem to solve. The shift in pattern matters more than the total.'
  };
  var HEALTHY_COPY = {
    dog: 'Healthy dog rest is layered — most of the day is light, easily interrupted sleep, with several stretches reaching deeper rest. Look for easy waking, smooth stretching, and re-engagement with the environment within a minute or two.',
    cat: 'Healthy cat rest is layered — most of the day is light, easily interrupted sleep, with several stretches reaching deep rest. Look for easy waking, deep stretching, brief grooming, and re-engagement with the environment.'
  };
  var SIGNS = {
    dog: [
      'A sudden, significant increase in sleep over days or a few weeks',
      'Difficulty settling, pacing, or restlessness at night',
      'Apparent disorientation or distress on waking',
      'Loud snoring, gasping, or sleep that seems labored',
      'Loss of interest in food, walks, or familiar people alongside sleep changes'
    ],
    cat: [
      'A sudden, significant increase in sleep over days or a few weeks',
      'Restlessness, pacing, or vocalizing at night — especially in senior cats',
      'Hiding more than usual or seeking unusual sleep spots',
      'Apparent disorientation or distress on waking',
      'Loss of interest in food, play, or familiar people alongside sleep changes'
    ]
  };
  var ENV = {
    dog: [
      'A consistent, supportive sleep surface — orthopedic for large or senior dogs',
      'A predictable evening rhythm with meals and last walk at similar times',
      'A cool, quiet, low-stimulation rest space',
      'Daily movement that genuinely tires the body and the mind',
      'Calm wind-down before bed — avoid intense play immediately before sleep'
    ],
    cat: [
      'Multiple safe rest spots — elevated, enclosed, or warm — so the cat can choose',
      'A predictable household rhythm with meals and quiet times at similar hours',
      'A warm, draft-free environment, especially for senior cats with stiffer joints',
      'Short daily play sessions that engage hunting drive and tire the mind',
      'Calm wind-down before sleep — avoid intense play immediately before bedtime'
    ]
  };

  function applyAdj(range, adj) { return adj ? [range[0] + adj[0], range[1] + adj[1]] : range; }
  function clampRange(r) {
    var low = Math.max(8, Math.min(22, r[0]));
    var high = Math.max(low + 1, Math.min(22, r[1]));
    return [low, high];
  }

  // Range band domain: 8–24h
  var DOMAIN_LO = 8, DOMAIN_HI = 24;
  function pct(v) { return Math.max(0, Math.min(100, (v - DOMAIN_LO) / (DOMAIN_HI - DOMAIN_LO) * 100)); }

  function init(root) {
    if (root.dataset.lplInit === '1') return;
    root.dataset.lplInit = '1';

    var species = root.getAttribute('data-species') || 'dog';
    var form = root.querySelector('[data-lpl-form]');
    if (!form) return;

    var errorEl    = form.querySelector('[data-error]');
    var resetBtn   = form.querySelector('[data-reset]');
    var resultEl   = root.querySelector('[data-result]');
    var rangeEl    = root.querySelector('[data-result-range]');
    var summaryEl  = root.querySelector('[data-result-summary]');
    var normalEl   = root.querySelector('[data-normal]');
    var ageEl      = root.querySelector('[data-age-change]');
    var healthyEl  = root.querySelector('[data-healthy]');
    var signsEl    = root.querySelector('[data-signs]');
    var envEl      = root.querySelector('[data-env]');
    var bandMarker = root.querySelector('[data-band-marker]');
    var bandSpan   = root.querySelector('[data-band-span]');

    function clearError() { if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; } }

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        form.reset();
        if (resultEl) resultEl.hidden = true;
        clearError();
      });
    }

    function fillList(el, items) {
      el.innerHTML = '';
      items.forEach(function (item) {
        var li = document.createElement('li');
        li.textContent = item;
        el.appendChild(li);
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError();

      var age      = (form.querySelector('input[name="age"]:checked') || {}).value || 'adult';
      var activity = (form.querySelector('input[name="activity"]:checked') || {}).value || 'moderate';
      var lifestyle = (form.querySelector('input[name="lifestyle"]:checked') || {}).value || '';
      var advanced  = ((form.querySelector('input[name="advanced"]:checked') || {}).value || 'no') === 'yes';
      var size     = (form.querySelector('input[name="size"]:checked') || {}).value || 'medium';

      var range = (BASE_RANGE[species] && BASE_RANGE[species][age]) || [12, 14];
      range = range.slice();

      if (species === 'dog') {
        range = applyAdj(range, DOG_SIZE_ADJ[size]);
        range = applyAdj(range, DOG_LIFESTYLE_ADJ[lifestyle]);
      } else {
        range = applyAdj(range, CAT_LIFESTYLE_ADJ[lifestyle]);
      }
      range = applyAdj(range, ACTIVITY_ADJ[activity]);
      if (advanced) range = applyAdj(range, ADVANCED_ADJ);
      range = clampRange(range);

      rangeEl.textContent = range[0] + '–' + range[1];
      summaryEl.textContent = INTERP[species][age] || '';
      normalEl.textContent = NORMAL_COPY[species][age] || '';
      ageEl.textContent = AGE_CHANGE_COPY[species];
      healthyEl.textContent = HEALTHY_COPY[species];
      fillList(signsEl, SIGNS[species]);
      fillList(envEl, ENV[species]);

      // Range band update
      if (bandMarker && bandSpan) {
        var mid = (range[0] + range[1]) / 2;
        bandMarker.style.left = pct(mid) + '%';
        var lo = pct(range[0]);
        var hi = pct(range[1]);
        bandSpan.style.left = lo + '%';
        bandSpan.style.width = (hi - lo) + '%';
      }

      resultEl.hidden = false;
      requestAnimationFrame(function () {
        resultEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function ready() { document.querySelectorAll('[data-lpl-sc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-lpl-sc]');
    if (root) init(root);
  });
}());

  } catch(e) { console.error(e); }
})();
})();
